// import React, { useEffect, useState, useRef } from "react";
// import axios from "axios";
// import { Link, useNavigate } from "react-router-dom";
// import ReactPaginate from "react-paginate";
// import Swal from "sweetalert2";
// import DealModal from "./DealModal";
// import withPermission from '../../../utils/withPermission';
// import PurchaseOrderForm from '../../purchaseorder/PurchaseOrderForm';
// import ProformaInvoiceModal from '../../ProformaInvoice/ProformaInvoiceModal';
// import { FaFilter } from "react-icons/fa";
// import { Offcanvas } from 'react-bootstrap';
// import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';


// const OrderDealList = () => {
//     const [deals, setDeals] = useState([]);
//     const [showModal, setShowModal] = useState(false);
//     const [selectedDealId, setSelectedDealId] = useState(null);
//     const [selectedDealData, setSelectedDealData] = useState(null);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [pageCount, setPageCount] = useState(0);
//     const [searchQuery, setSearchQuery] = useState("");
//     const [organisations, setOrganisation] = useState([]);
//     const [showVendorsModal, setShowVendorsModal] = useState(false);
//     const [selectedVendorId, setSelectedVendorId] = useState(null);
//     const [proformainvoices, setPerformaInvoices] = useState("");
//     const [showInvoiceDetails, setShowInvoiceDetails] = useState(null);
//     const [showVendorDetails, setShowVendorDetails] = useState(false);
//     const [vendorNames, setVendorNames] = useState({});
//     const [poId, setPoId] = useState(null);
//     const [activeTab, setActiveTab] = useState(0);

//     const [selectedQuotationProducts, setSelectedQuotationProducts] = useState([]);
//     const [showPurchaseOrderModal, setShowPurchaseOrderModal] = useState(false);
//     const [vendors, setVendors] = useState([]);
//     const [selectedQuotationId, setSelectedQuotationId] = useState(null);
//     const [selectedQuotationData, setSelectedQuotationData] = useState(null);
//     const [quotations, setQuotations] = useState([]);

//     const WithCreatePermission = withPermission(({ children }) => children, ["deal-create"]);
//     const WithEditPermission = withPermission(({ children }) => children, ["deal-edit"]);
//     const WithDeletePermission = withPermission(({ children }) => children, ["deal-delete"]);

//     const debounceTimeoutRef = useRef(null);
//     const [showDropdown, setShowDropdown] = useState(false);
//     const [dateFilterDropdown, setDateFilterDropdown] = useState(false);
//     const [dateRange, setDateRange] = useState({ from: '', to: '' });
//     const [orgFilter, setorgFilter] = useState('');
//     const [typeFilter, setTypeFilter] = useState('');
//     const [filterDropdown, setFilterDropdown] = useState(null);
//     const navigate = useNavigate();

//     useEffect(() => {
//         if (debounceTimeoutRef.current) {
//             clearTimeout(debounceTimeoutRef.current);
//         }

//         debounceTimeoutRef.current = setTimeout(() => {
//             fetchDeals(1, searchQuery);
//         }, searchQuery ? 1500 : 0);

//         return () => {
//             if (debounceTimeoutRef.current) {
//                 clearTimeout(debounceTimeoutRef.current);
//             }
//         };
//     }, [searchQuery, orgFilter, typeFilter]);

//     const fetchDeals = async (page = 1) => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem("user-info"));
//             const origin = localStorage.getItem('user-origin');

//             const token = userInfo?.token;
//             let params = { page, stage: "order", };


//             if (searchQuery) params.search = searchQuery;
//             if (dateRange?.from) params.from_date = dateRange.from;
//             if (dateRange?.to) params.to_date = dateRange.to;
//             if (orgFilter) params.organisation_id = orgFilter; // Only add if not empty
//             if (typeFilter) params.lead_source = typeFilter;
//             const response = await axios.get(`${backendUrl}/api/deals`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 params,
//             });

//             const { data, current_page, last_page } = response.data.data;


//             setDeals(data);
//             setCurrentPage(current_page);
//             setPageCount(last_page);
//         } catch (error) {
//             console.error("Error fetching deals:", error);
//         }
//     };
//     const fetchQuotations = async (page = 1) => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const url = `${backendUrl}/api/quotations?project_id=${selectedDealData?.project_id}&client_id=${selectedDealData?.client_id}&page=${page}`;
//             const response = await axios.get(url, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });

//             const quotationData = response.data.quotations || [];
//             setQuotations(quotationData);

//             // Update vendor names and vendors
//             const vendorNamesObj = {};
//             const vendorsObj = {};

//             quotationData.forEach(quotation => {
//                 quotation.product_item_details.forEach(product => {
//                     const vendor = product.product?.vendor;
//                     if (vendor && !vendorNamesObj[vendor.id]) {
//                         vendorNamesObj[vendor.id] = vendor.name;
//                         vendorsObj[vendor.id] = vendor.currency;
//                     }
//                 });
//             });

//             setVendorNames(vendorNamesObj);
//             setVendors(vendorsObj);

//             const totalPages = response.data.meta?.total_pages || 1;
//             setPageCount(totalPages);

//             setCurrentPage(page);
//         } catch (error) {
//             console.error('Error fetching quotations:', error);
//         }
//     };


//     const fetchOrganisation = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/organisation`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },

//             });

//             const data = response.data.data;

//             setOrganisation(data);

//         } catch (error) {
//             console.error(`Error fetching :`, error);
//         }
//     };
//     useEffect(() => {
//         fetchOrganisation();
//     }, []);
//     const handleSearchChange = (e) => setSearchQuery(e.target.value);

//     const handlePageClick = (data) => {
//         const selectedPage = data.selected + 1;
//         fetchDeals(selectedPage);
//     };

//     const editDeal = async (contactId, updatedData) => {
//         try {

//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');

//             const token = userInfo?.token;

//             // Corrected API endpoint with dynamic contact_type for editing
//             const response = await axios.put(`${backendUrl}/api/deals/${contactId}`, updatedData, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });
//             const updatedDeal = response.data.Data;

//             if (updatedDeal) {
//                 setDeals((prevDeal) =>
//                     prevDeal.map((contact) => (contact.id === updatedDeal.id ? updatedDeal : contact))
//                 );
//             } else {
//                 console.error('Update failed, no data returned.');
//             }

//             handleCloseModal();
//         } catch (error) {
//             if (error.response?.data?.errors) {
//                 return error.response.data.errors; // Return validation errors
//             } else
//                 console.error(`Error updating`, error);
//         }
//     };

//     const deleteDeal = async (id) => {
//         Swal.fire({
//             title: "Are you sure?",
//             text: "You won't be able to revert this!",
//             icon: "warning",
//             showCancelButton: true,
//             confirmButtonColor: "#d33",
//             cancelButtonColor: "#3085d6",
//             confirmButtonText: "Yes, delete it!"
//         }).then(async (result) => {
//             if (result.isConfirmed) {
//                 try {
//                     const backendUrl = process.env.REACT_APP_BACKEND_URL;
//                     const userInfo = JSON.parse(localStorage.getItem('user-info'));
//                     const origin = localStorage.getItem('user-origin');
//                     const token = userInfo?.token;

//                     // Corrected API endpoint with dynamic contact_type for deleting
//                     await axios.delete(`${backendUrl}/api/deals/${id}`, {
//                         headers: {
//                             Authorization: `Bearer ${token}`,
//                             'Tenant-Origin': origin,
//                         },
//                     });

//                     setDeals(deals.filter((contact) => contact.id !== id));
//                     Swal.fire(
//                         "Deleted!",
//                         "The deal has been deleted.",
//                         "success"
//                     );
//                 } catch (error) {
//                     console.error('Error deleting deal:', error);
//                     Swal.fire(
//                         "Error!",
//                         "Failed to delete deal. Please try again.",
//                         "error"
//                     );
//                 }
//             }
//         });
//     };
//     const handleShowModal = (contactId = null) => {
//         if (contactId) {
//             const contactToEdit = deals.find((contact) => contact.id === contactId);
//             if (contactToEdit) {
//                 setSelectedDealData(contactToEdit);
//             }
//         } else {
//             setSelectedDealData(null);
//         }
//         setSelectedDealId(contactId);
//         setShowModal(true);
//     };
//     const handleCloseModal = () => {
//         setShowModal(false);
//         setSelectedDealId(null);
//         setSelectedDealData(null);
//     };
//     const handleClosePurchaseOrderModal = () => {
//         setShowPurchaseOrderModal(false); // Close PO modal
//         setSelectedVendorId(null); // Reset selected vendor
//     };

//     const handleCloseVendorsModal = () => {
//         setShowVendorsModal(false);
//     };
//     const [showProformaModal, setShowProformaModal] = useState(false);
//     const [dropdownVisible, setDropdownVisible] = useState(false);


//     const handleVendorDropdownChange = (deal) => {
//         // Ensure that deal.quotation exists and then access the product_item_details
//         // const productsWithVendors = deal?.quotation?.product_item_details.filter(product => product.product?.vendor_id);
//         const productsWithVendors = (deal?.quotation?.product_item_details ?? [])
//             .filter(product => product.product?.vendor_id);

//         if (productsWithVendors.length > 0) {
//             // Extract vendor names and currencies
//             const vendorNamesObj = {};
//             const vendorsObj = {};

//             productsWithVendors.forEach(product => {
//                 const vendor = product.product?.vendor;
//                 if (vendor && !vendorNamesObj[vendor.id]) {
//                     vendorNamesObj[vendor.id] = vendor.name;
//                     vendorsObj[vendor.id] = vendor.currency;
//                 }
//             });

//             // Set states to reflect the filtered vendor data
//             setSelectedQuotationProducts(productsWithVendors);
//             setVendorNames(vendorNamesObj);
//             setVendors(vendorsObj);
//             setSelectedQuotationId(deal.quotation.id);  // Use deal's quotation ID
//             setSelectedQuotationData(deal.quotation);

//             setShowVendorsModal(true);
//         } else {
//             // Show error if no vendors associated
//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'error',
//                 title: 'No vendors associated with products in this quotation.',
//                 timer: 3000,
//                 timerProgressBar: false,
//                 showConfirmButton: false,
//                 didOpen: () => {
//                     const container = Swal.getContainer();
//                     container.style.top = '50px';
//                 }
//             });
//         }
//     };


//     const handleGenerateProformaInvoice = (deal) => {
//         const quotationDetails = deal?.quotation;

//         if (!quotationDetails || !quotationDetails.amount) {
//             console.log("No valid quotation or amount found.");
//             return;
//         }

//         // Convert amounts safely
//         const totalAmount = Number(quotationDetails.amount) || 0;

//         if (totalAmount <= 0) {
//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'warning',
//                 title: 'Quotation has no amount. Cannot create proforma invoice.',
//                 timer: 3000,
//                 showConfirmButton: false
//             });
//             return;
//         }

//         const totalReceived = (quotationDetails.proforma_invoices || []).reduce(
//             (sum, inv) => sum + (Number(inv.total_amount_received) || 0),
//             0
//         );

//         const balance = totalAmount - totalReceived;

//         console.log({ totalAmount, totalReceived, balance });

//         if (balance <= 0) {
//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'warning',
//                 title: 'Cannot create proforma invoice. Balance amount is 0.',
//                 timer: 3000,
//                 showConfirmButton: false
//             });
//             return;
//         }

//         // Open modal
//         setShowProformaModal(true);
//         setSelectedQuotationData(quotationDetails);
//     };





//     const handleCloseProformaModal = () => {
//         setShowProformaModal(false); // Close the modal
//         setSelectedQuotationData(null); // Clear selected data

//     };
//     const handleCreateProformaInvoice = (newInvoice) => {
//         setQuotations(prevQuotations => {
//             const updatedQuotations = prevQuotations.map(q =>
//                 q.id === newInvoice.quotation_id
//                     ? { ...q, proforma_invoices: [...q.proforma_invoices, newInvoice] }
//                     : q
//             );
//             console.log('Updated Quotations:', updatedQuotations); // Debugging
//             return updatedQuotations;
//         });
//     };


//     const handleCreatePurchaseOrder = (vendorId) => {
//         console.log('Vendor ID selected:', vendorId); // Debug log
//         setSelectedVendorId(vendorId);
//         setShowPurchaseOrderModal(true); // Show the Purchase Order modal
//         console.log('showPurchaseOrderModal set to:', true); // Debug log
//         setShowVendorsModal(false); // Close the vendor modal

//         setPoId(null);

//     };
//     const handleDateChange = (e) => {
//         const { name, value } = e.target;
//         setDateRange((prev) => ({ ...prev, [name]: value }));
//     };
//     const applyDateFilter = () => {
//         setDateFilterDropdown(false); // Close the dropdown after applying
//         fetchDeals();
//     };
//     const clearDateFilter = () => {
//         setDateRange({ from: "", to: "" }); // Reset date inputs
//     };
//     const handleFilterChange = (filterType, value) => {
//         if (filterType === 'org') setorgFilter(value);
//         if (filterType === 'type') setTypeFilter(value);

//         setFilterDropdown(null); // Close dropdown after selection
//     };
//     const splitOrderByRevenueType = (order) => {
//         const subscriptionItems = [];
//         const deploymentItems = [];
//         let subscriptionTotal = 0;
//         let deploymentTotal = 0;

//         order.quotation?.product_item_details?.forEach(item => {
//             const revenueType = item.product?.revenue_type;
//             const itemTotal = parseFloat(item.subtotal) || 0;

//             if (revenueType === 'deferred') {
//                 subscriptionItems.push(item);
//                 subscriptionTotal += itemTotal;
//             } else if (revenueType === 'immediate') {
//                 deploymentItems.push(item);
//                 deploymentTotal += itemTotal;
//             }
//         });

//         return {
//             subscription: {
//                 items: subscriptionItems,
//                 total: subscriptionTotal,
//                 count: subscriptionItems.length
//             },
//             deployment: {
//                 items: deploymentItems,
//                 total: deploymentTotal,
//                 count: deploymentItems.length
//             }
//         };
//     };

//     // Filter orders based on active tab
//     const getFilteredOrders = () => {
//         if (activeTab === 0) return deals; // All orders

//         return deals.filter(order => {
//             const revenueSplit = splitOrderByRevenueType(order);

//             if (activeTab === 1) { // Subscription tab
//                 return revenueSplit.subscription.count > 0;
//             }

//             if (activeTab === 2) { // Deployment tab
//                 return revenueSplit.deployment.count > 0;
//             }

//             return true;
//         });
//     };
//     const OrderTable = ({ deals }) => {
//         // Move your entire table rendering logic here from your original component
//         return (
//             <div>
//                 <table className="table align-middle table-nowrap table-check table-list">
//                     <thead className="table-sales-gradient">
//                         <tr>
//                             <th style={{ width: '20px' }} className="align-middle">
//                                 <div className="form-check font-size-16">
//                                     <input className="form-check-input" type="checkbox" id="checkAll" />
//                                     <label className="form-check-label" htmlFor="checkAll"></label>
//                                 </div>
//                             </th>
//                             <th className="align-middle">#</th>
//                             <th className="align-middle">Name</th>
//                             <th className="align-middle">Organisation
//                                 <div className="dropdown d-inline-block">
//                                     <FaFilter
//                                         className="ms-2 cursor-pointer filter-color"
//                                         onClick={() => setFilterDropdown(filterDropdown === 'org' ? null : 'org')}
//                                     />
//                                     {filterDropdown === 'org' && (
//                                         <ul className="dropdown-menu show">
//                                             <li><button className="dropdown-item" onClick={() => handleFilterChange('org', '')}>All</button></li>
//                                             {organisations.map((type) => (
//                                                 <li key={type.id}>
//                                                     <button className="dropdown-item" onClick={() => handleFilterChange('org', type.id)}>
//                                                         {type.name}
//                                                     </button>
//                                                 </li>
//                                             ))}
//                                         </ul>
//                                     )}
//                                 </div>
//                             </th>
//                             <th className="align-middle">Lead Source
//                                 <div className="dropdown d-inline-block">
//                                     <FaFilter
//                                         className="ms-2 cursor-pointer filter-color"
//                                         onClick={() => setFilterDropdown(filterDropdown === 'type' ? null : 'type')}
//                                     />
//                                     {filterDropdown === 'type' && (
//                                         <ul className="dropdown-menu show">
//                                             <li>
//                                                 <button className="dropdown-item" onClick={() => handleFilterChange('type', '')}>
//                                                     All
//                                                 </button>
//                                             </li>
//                                             <li>
//                                                 <button className="dropdown-item" onClick={() => handleFilterChange('type', 'partner')}>
//                                                     Partner
//                                                 </button>
//                                             </li>
//                                             <li>
//                                                 <button className="dropdown-item" onClick={() => handleFilterChange('type', 'consultant')}>
//                                                     Consultant
//                                                 </button>
//                                             </li>
//                                             <li>
//                                                 <button className="dropdown-item" onClick={() => handleFilterChange('type', 'inside sale')}>
//                                                     Inside Sales
//                                                 </button>
//                                             </li>
//                                             <li>
//                                                 <button className="dropdown-item" onClick={() => handleFilterChange('type', 'sales generated')}>
//                                                     Sales Generated
//                                                 </button>
//                                             </li>

//                                         </ul>
//                                     )}
//                                 </div>
//                             </th>
//                             <th className="align-middle">Value</th>
//                             <th className="align-middle">Closed Date
//                                 <div className="dropdown d-inline-block">
//                                     <FaFilter
//                                         className="ms-2 cursor-pointer filter-color"
//                                         onClick={() => setDateFilterDropdown(!dateFilterDropdown)}
//                                     />
//                                     {dateFilterDropdown && (
//                                         <div className="dropdown-menu show p-3" style={{ minWidth: '250px' }}>
//                                             <label className="form-label">From</label>
//                                             <input type="date" className="form-control mb-2" name="from" value={dateRange.from} onChange={handleDateChange} />

//                                             <label className="form-label">To</label>
//                                             <input type="date" className="form-control mb-2" name="to" value={dateRange.to} onChange={handleDateChange} />

//                                             <div className="text-end mt-3">
//                                                 <button className="btn btn-primary btn-sm d-inline-block w-auto me-2" onClick={applyDateFilter}>
//                                                     Apply
//                                                 </button>
//                                                 <button className="btn btn-secondary btn-sm d-inline-block w-auto" onClick={clearDateFilter}>
//                                                     Clear
//                                                 </button>
//                                             </div>
//                                         </div>
//                                     )}
//                                 </div>
//                             </th>
//                             <th className="align-middle">Action</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {deals.length > 0 ? (
//                             deals.map((deal, index) => (
//                                 <OrderTableRow key={deal.id} deal={deal} index={index} />
//                             ))
//                         ) : (
//                             <tr>
//                                 <td colSpan="8" className="text-center">No orders found.</td>
//                             </tr>
//                         )}
//                     </tbody>
//                 </table>
//             </div>
//         );
//     };

//     // Separate row component for better organization
//     // const OrderTableRow = ({ deal, index }) => {
//     //     // Move your row rendering logic here
//     //     const revenueSplit = splitOrderByRevenueType(deal);

//     //     return (
//     //         <tr key={deal.id}>
//     //             <td>
//     //                 <div className="form-check font-size-16">
//     //                     <input
//     //                         className="form-check-input"
//     //                         type="checkbox"
//     //                         id={`transactionCheck${index}`}
//     //                     />
//     //                     <label
//     //                         className="form-check-label"
//     //                         htmlFor={`transactionCheck${index}`}
//     //                     ></label>
//     //                 </div>
//     //             </td>
//     //             <td>{index + 1}</td>
//     //             <td>
//     //                 <Link to={`/deal/details/${deal.id}`} className="dropdown-item">
//     //                     {deal.name}
//     //                 </Link>
//     //             </td>
//     //             <td>{deal.organisation ? deal.organisation.name : " "}</td>
//     //             <td>{deal.lead_source}</td>
//     //             <td>
//     //                 {Number(deal.value || 0).toLocaleString('en-US', {
//     //                     minimumFractionDigits: 2,
//     //                     maximumFractionDigits: 2
//     //                 })}
//     //                 {/* Show revenue split breakdown */}
//     //                 <div className="revenue-breakdown small text-muted">
//     //                     {revenueSplit.deployment.total > 0 && (
//     //                         <span>Deployment: {revenueSplit.deployment.total.toLocaleString()}</span>
//     //                     )}
//     //                     {revenueSplit.subscription.total > 0 && revenueSplit.deployment.total > 0 && ' | '}
//     //                     {revenueSplit.subscription.total > 0 && (
//     //                         <span>Subscription: {revenueSplit.subscription.total.toLocaleString()}</span>
//     //                     )}
//     //                 </div>
//     //             </td>
//     //             <td>{deal.closed_date}</td>
//     //             <td>
//     //                 {/* Your existing action dropdown */}
//     //                 <div className="dropdown">
//     //                     <i
//     //                         className="mdi mdi-dots-horizontal font-size-18"
//     //                         data-bs-toggle="dropdown"
//     //                         aria-expanded="false"
//     //                         style={{ cursor: "pointer" }}
//     //                     ></i>
//     //                     <ul className="dropdown-menu dropdown-menu-end font-size-14">
//     //                         <li>
//     //                             <Link to={`/deal/details/${deal.id}`} className="dropdown-item">
//     //                                 View Details
//     //                             </Link>
//     //                         </li>
//     //                         <li>
//     //                             <WithEditPermission>
//     //                                 <button
//     //                                     className="dropdown-item"
//     //                                     onClick={() => handleShowModal(deal.id)}

//     //                                 >
//     //                                     Edit
//     //                                 </button>
//     //                             </WithEditPermission>
//     //                         </li>
//     //                         <li>
//     //                             <button
//     //                                 className="dropdown-item"
//     //                                 onClick={() => handleGenerateProformaInvoice(deal, revenueSplit)}
//     //                             >
//     //                                 Generate Proforma Invoice
//     //                             </button>
//     //                         </li>
//     //                         {deal.quotation?.proforma_invoices?.length > 0 && (

//     //                             <li>

//     //                                 <Link to={`/proformainvoice?quotation_id=${deal.quotation_id}`} className="dropdown-item">
//     //                                     Proforma Invoice List
//     //                                 </Link>
//     //                             </li>
//     //                         )}
//     //                         <li>
//     //                             <button
//     //                                 className="dropdown-item"
//     //                                 onClick={() => handleVendorDropdownChange(deal)}
//     //                             >
//     //                                 Generate Vendor PO
//     //                             </button>
//     //                         </li>
//     //                         {deal.quotation?.purchase_order?.length > 0 && (

//     //                             <li>
//     //                                 <Link to={`/purchase-order?quotation_id=${deal?.quotation_id}`} className="dropdown-item">
//     //                                     Vendor PO Details
//     //                                 </Link>
//     //                             </li>
//     //                         )}
//     //                         <li>
//     //                             <WithDeletePermission>
//     //                                 <button
//     //                                     className="dropdown-item"
//     //                                     onClick={() => deleteDeal(deal.id)}

//     //                                 >
//     //                                     Delete
//     //                                 </button>
//     //                             </WithDeletePermission>
//     //                         </li>
//     //                     </ul>
//     //                 </div>
//     //             </td>
//     //         </tr>
//     //     );
//     // };

//     const OrderTableRow = ({ deal, index }) => {
//   const [expanded, setExpanded] = useState(false);
//   const revenueSplit = splitOrderByRevenueType(deal);

//   const toggleExpand = () => {
//     setExpanded(!expanded);
//   };

//   return (
//     <>
//       {/* Parent Order Row */}
//       <tr key={deal.id}>
//         <td>
//           <div className="form-check font-size-16">
//             <input
//               className="form-check-input"
//               type="checkbox"
//               id={`transactionCheck${index}`}
//             />
//             <label
//               className="form-check-label"
//               htmlFor={`transactionCheck${index}`}
//             ></label>
//           </div>
//         </td>
//         <td>{index + 1}</td>
//         <td>
//           <button
//             className="btn btn-sm btn-link p-0"
//             onClick={toggleExpand}
//           >
//             {expanded ? "−" : "+"}
//           </button>{" "}
//           <Link to={`/deal/details/${deal.id}`} className="dropdown-item">
//             {deal.name}
//           </Link>
//         </td>
//         <td>{deal.organisation ? deal.organisation.name : " "}</td>
//         <td>{deal.lead_source}</td>
//         <td>
//           {Number(deal.value || 0).toLocaleString("en-US", {
//             minimumFractionDigits: 2,
//             maximumFractionDigits: 2,
//           })}
//           <div className="revenue-breakdown small text-muted">
//             {revenueSplit.deployment.total > 0 && (
//               <span>
//                 Deployment: {revenueSplit.deployment.total.toLocaleString()}
//               </span>
//             )}
//             {revenueSplit.subscription.total > 0 &&
//               revenueSplit.deployment.total > 0 &&
//               " | "}
//             {revenueSplit.subscription.total > 0 && (
//               <span>
//                 Subscription: {revenueSplit.subscription.total.toLocaleString()}
//               </span>
//             )}
//           </div>
//         </td>
//         <td>{deal.closed_date}</td>
//         <td>
//           {/* Main Action Dropdown */}
//           <div className="dropdown">
//             <i
//               className="mdi mdi-dots-horizontal font-size-18"
//               data-bs-toggle="dropdown"
//               aria-expanded="false"
//               style={{ cursor: "pointer" }}
//             ></i>
//             <ul className="dropdown-menu dropdown-menu-end font-size-14">
//               <li>
//                 <Link to={`/deal/details/${deal.id}`} className="dropdown-item">
//                   View Details
//                 </Link>
//               </li>
//               <li>
//                 <WithEditPermission>
//                   <button
//                     className="dropdown-item"
//                     onClick={() => handleShowModal(deal.id)}
//                   >
//                     Edit
//                   </button>
//                 </WithEditPermission>
//               </li>
//               <li>
//                 <button
//                   className="dropdown-item"
//                   onClick={() => handleGenerateProformaInvoice(deal, revenueSplit)}
//                 >
//                   Generate Proforma Invoice
//                 </button>
//               </li>
//               {deal.quotation?.proforma_invoices?.length > 0 && (
//                 <li>
//                   <Link
//                     to={`/proformainvoice?quotation_id=${deal.quotation_id}`}
//                     className="dropdown-item"
//                   >
//                     Proforma Invoice List
//                   </Link>
//                 </li>
//               )}
//               <li>
//                 <button
//                   className="dropdown-item"
//                   onClick={() => handleVendorDropdownChange(deal)}
//                 >
//                   Generate Vendor PO
//                 </button>
//               </li>
//               {deal.quotation?.purchase_order?.length > 0 && (
//                 <li>
//                   <Link
//                     to={`/purchase-order?quotation_id=${deal?.quotation_id}`}
//                     className="dropdown-item"
//                   >
//                     Vendor PO Details
//                   </Link>
//                 </li>
//               )}
//               <li>
//                 <WithDeletePermission>
//                   <button
//                     className="dropdown-item"
//                     onClick={() => deleteDeal(deal.id)}
//                   >
//                     Delete
//                   </button>
//                 </WithDeletePermission>
//               </li>
//             </ul>
//           </div>
//         </td>
//       </tr>

//       {/* Expanded Child Rows */}
//       {expanded && (
//         <>
//           {revenueSplit.deployment.total > 0 && (
//             <tr className="bg-light">
//               <td></td>
//               <td colSpan="3">Deployment</td>
//               <td colSpan="2">
//                 {revenueSplit.deployment.total.toLocaleString()}
//               </td>
//               <td>
//                 {/* Deployment Actions */}
//                 <button className="btn btn-sm btn-outline-primary me-2">
//                   Set Start Date
//                 </button>
//                 <button className="btn btn-sm btn-outline-primary me-2">
//                   Set End Date
//                 </button>
//                 <button className="btn btn-sm btn-outline-primary">
//                   Payment Terms
//                 </button>
//               </td>
//             </tr>
//           )}

//           {revenueSplit.subscription.total > 0 && (
//             <tr className="bg-light">
//               <td></td>
//               <td colSpan="3">Subscription</td>
//               <td colSpan="2">
//                 {revenueSplit.subscription.total.toLocaleString()}
//               </td>
//               <td>
//                 {/* Subscription Actions */}
//                 <button className="btn btn-sm btn-outline-success me-2">
//                   Set Start Date
//                 </button>
//                 <button className="btn btn-sm btn-outline-success me-2">
//                   Set End Date
//                 </button>
//                 <button className="btn btn-sm btn-outline-success">
//                   Payment Terms
//                 </button>
//               </td>
//             </tr>
//           )}
//         </>
//       )}
//     </>
//   );
// };

//     return (
//         <div className="main-content">
//             <div className="page-content">
//                 <div className="container-fluid">
//                     <div className="row">
//                         <div className="col-12">
//                             <div className="page-title-box d-sm-flex align-items-center justify-content-between">
//                                 <h4 className="mb-sm-0 font-size-18">Orders</h4>
//                             </div>
//                         </div>
//                     </div><br />

//                     <div className="row">
//                         <div className="col-12">
//                             <div className="card">
//                                 <div className="card-body">
//                                     <Tabs selectedIndex={activeTab} onSelect={setActiveTab}>
//                                         <TabList>
//                                             <Tab>All Orders</Tab>
//                                             <Tab>Subscriptions</Tab>
//                                             <Tab>Deployment</Tab>
//                                         </TabList>

//                                         <TabPanel>
//                                             {/* All orders content - your existing table goes here */}
//                                             <OrderTable deals={getFilteredOrders()} />
//                                         </TabPanel>

//                                         <TabPanel>
//                                             {/* Subscription orders content */}
//                                             <OrderTable deals={getFilteredOrders()} />
//                                         </TabPanel>

//                                         <TabPanel>
//                                             {/* Deployment orders content */}
//                                             <OrderTable deals={getFilteredOrders()} />
//                                         </TabPanel>
//                                     </Tabs>
//                                     <div className="d-flex justify-content-between mb-3">
//                                         <div className="search-box me-2 mb-2 d-inline-block">
//                                             <div className="position-relative">

//                                             </div>
//                                         </div>

//                                         <WithCreatePermission>
//                                             {/* <button
//                                                 type="button"
//                                                 className="btn btn-secondary btn-rounded waves-effect waves-light mb-3"
//                                                 onClick={() => setShowModal(true)}
//                                             >
//                                                 <i className="mdi mdi-plus me-1"></i> Add
//                                             </button> */}
//                                         </WithCreatePermission>
//                                     </div>
//                                     {showVendorsModal && (
//                                         <Offcanvas
//                                             show={showVendorsModal}
//                                             onHide={handleCloseVendorsModal}
//                                             placement="end"
//                                             backdrop="static"
//                                             style={{ width: '550px', borderLeft: '1px solid rgba(0,0,0,0.1)' }}
//                                         >
//                                             {/* Header with gradient background */}
//                                             <Offcanvas.Header
//                                                 closeButton
//                                                 className="border-bottom pb-2"
//                                                 style={{
//                                                     background: 'linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%)',
//                                                     padding: '1.5rem 2rem'
//                                                 }}
//                                             >
//                                                 <div>
//                                                     <Offcanvas.Title
//                                                         as="h5"
//                                                         style={{
//                                                             fontWeight: '600',
//                                                             fontSize: '1.4rem',
//                                                             color: '#2c3e50',
//                                                             marginBottom: '0.25rem'
//                                                         }}
//                                                     >
//                                                         Vendor Selection
//                                                     </Offcanvas.Title>
//                                                     <p className="text-muted mb-0" style={{ fontSize: '0.9rem' }}>
//                                                         Select vendor to {selectedQuotationData?.purchase_order?.length ? 'view' : 'create'} purchase order
//                                                     </p>
//                                                 </div>
//                                             </Offcanvas.Header>

//                                             {/* Body with custom scrollbar */}
//                                             <Offcanvas.Body
//                                                 className="px-0"
//                                                 style={{
//                                                     overflowY: 'auto',
//                                                     scrollbarWidth: 'thin',
//                                                     scrollbarColor: '#d1d8e0 #f1f3f5'
//                                                 }}
//                                             >
//                                                 <div className="px-4 pt-3 pb-2">
//                                                     {/* <div className="alert alert-info py-2 mb-3" style={{ fontSize: '0.9rem' }}>
//                                                                     <i className="mdi mdi-information-outline me-2"></i>
//                                                                 </div> */}
//                                                 </div>

//                                                 {/* Vendor list with cards */}
//                                                 <div className="px-4">
//                                                     {selectedQuotationProducts.length > 0 ? (
//                                                         <div className="vendor-list">
//                                                             {selectedQuotationProducts.map((product, index) => {
//                                                                 const vendorName = vendorNames[product.product?.vendor_id];
//                                                                 const vendorId = product.product?.vendor_id;
//                                                                 // const quotation = quotations.find(q => q.id === selectedQuotationId);
//                                                                 const quotation = selectedQuotationData;

//                                                                 const hasPO = quotation?.purchase_order?.some(po => po.vendor_id === vendorId);
//                                                                 const existingPO = hasPO ? quotation.purchase_order.find(po => po.vendor_id === vendorId) : null;

//                                                                 return (
//                                                                     <div
//                                                                         key={index}
//                                                                         className="card mb-3 shadow-sm"
//                                                                         style={{
//                                                                             borderLeft: hasPO ? '4px solid #4e73df' : '4px solid #f6c23e',
//                                                                             transition: 'all 0.2s ease'
//                                                                         }}
//                                                                     >
//                                                                         <div className="card-body py-3 px-4">
//                                                                             <div className="d-flex justify-content-between align-items-center">
//                                                                                 <div>
//                                                                                     <h6 className="mb-1" style={{ fontWeight: '600' }}>
//                                                                                         {vendorName || 'Unknown Vendor'}
//                                                                                     </h6>
//                                                                                     <small className="text-muted">
//                                                                                         {product.product?.product_name || 'Product not specified'}
//                                                                                     </small>
//                                                                                     {existingPO && (
//                                                                                         <div className="mt-1">
//                                                                                             <small className="text-primary">
//                                                                                                 PO #: {existingPO.ref_no}
//                                                                                             </small>
//                                                                                         </div>
//                                                                                     )}
//                                                                                 </div>
//                                                                                 <div>
//                                                                                     {hasPO ? (
//                                                                                         <button
//                                                                                             className="btn btn-sm"
//                                                                                             onClick={() => {
//                                                                                                 navigate(`/purchase-order/details/${existingPO.id}`);
//                                                                                                 handleCloseVendorsModal();
//                                                                                             }}
//                                                                                             style={{
//                                                                                                 background: '#4e73df',
//                                                                                                 color: 'white',
//                                                                                                 borderRadius: '6px',
//                                                                                                 padding: '0.35rem 1rem',
//                                                                                                 fontWeight: '500'
//                                                                                             }}
//                                                                                         >
//                                                                                             <i className="mdi mdi-eye-outline me-1"></i> View PO Details
//                                                                                         </button>
//                                                                                     ) : (
//                                                                                         <button
//                                                                                             className="btn btn-sm"
//                                                                                             onClick={() => handleCreatePurchaseOrder(vendorId)}
//                                                                                             style={{
//                                                                                                 background: '#f6c23e',
//                                                                                                 color: '#2c3e50',
//                                                                                                 borderRadius: '6px',
//                                                                                                 padding: '0.35rem 1rem',
//                                                                                                 fontWeight: '500'
//                                                                                             }}
//                                                                                         >
//                                                                                             <i className="mdi mdi-plus-circle-outline me-1"></i> Create PO
//                                                                                         </button>
//                                                                                     )}
//                                                                                 </div>
//                                                                             </div>
//                                                                         </div>
//                                                                     </div>
//                                                                 );
//                                                             })}
//                                                         </div>
//                                                     ) : (
//                                                         <div className="text-center py-5">
//                                                             <div className="mb-3" style={{ fontSize: '3rem', color: '#e9ecef' }}>
//                                                                 <i className="mdi mdi-account-group-outline"></i>
//                                                             </div>
//                                                             <h5 className="text-muted mb-2">No Vendors Available</h5>
//                                                             <p className="text-muted" style={{ fontSize: '0.9rem' }}>
//                                                                 This quotation doesn't have any products with assigned vendors.
//                                                             </p>
//                                                         </div>
//                                                     )}
//                                                 </div>
//                                             </Offcanvas.Body>

//                                             {/* Footer with action buttons */}
//                                             <div
//                                                 className="border-top px-4 py-3 d-flex justify-content-between align-items-center"
//                                                 style={{ background: '#f8f9fa' }}
//                                             >
//                                                 <div>
//                                                     <span className="text-muted small">
//                                                         Showing {selectedQuotationProducts.length} vendor{selectedQuotationProducts.length !== 1 ? 's' : ''}
//                                                     </span>
//                                                 </div>
//                                                 <div>
//                                                     <button
//                                                         className="btn btn-outline-secondary btn-sm"
//                                                         onClick={handleCloseVendorsModal}
//                                                         style={{
//                                                             borderRadius: '6px',
//                                                             padding: '0.35rem 1rem',
//                                                             fontWeight: '500'
//                                                         }}
//                                                     >
//                                                         <i className="mdi mdi-close-circle-outline me-1"></i> Close
//                                                     </button>
//                                                 </div>
//                                             </div>
//                                         </Offcanvas>
//                                     )}

//                                     <div className="d-flex justify-content-end pagination-sm">
//                                         <ReactPaginate
//                                             previousLabel={'<'}
//                                             nextLabel={'>'}
//                                             breakLabel={'...'}
//                                             pageCount={pageCount}
//                                             marginPagesDisplayed={2}
//                                             pageRangeDisplayed={3}
//                                             onPageChange={handlePageClick}
//                                             containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
//                                             pageClassName={'page-item'}
//                                             pageLinkClassName={'page-link'}
//                                             previousClassName={'page-item previous'}
//                                             previousLinkClassName={'page-link'}
//                                             nextClassName={'page-item next'}
//                                             nextLinkClassName={'page-link'}
//                                             breakClassName={'page-item'}
//                                             breakLinkClassName={'page-link'}
//                                             activeClassName={'active'}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             {showPurchaseOrderModal && (
//                 <PurchaseOrderForm
//                     showModal={showPurchaseOrderModal}
//                     // purchaseorderData={selectedPurchaseOrder}
//                     poId={poId}
//                     vendorId={selectedVendorId}
//                     products={selectedQuotationProducts}
//                     handleClose={handleClosePurchaseOrderModal}
//                     projectId={selectedDealData?.project_id}
//                     quotationId={selectedQuotationId}
//                     vendors={vendors}
//                     // setPurchaseOrders={setPurchaseOrders}
//                     isQuotationParent={true}
//                     fetchQuotations={fetchQuotations}

//                 />

//             )}
//             {showProformaModal && (
//                 <ProformaInvoiceModal
//                     showModal={showProformaModal}
//                     quotationData={selectedQuotationData}
//                     handleClose={handleCloseProformaModal}
//                     quotationId={selectedDealData?.quotation_id}
//                     handleCreate={handleCreateProformaInvoice}
//                     fetchDeals={fetchDeals}


//                 />
//             )}
//             <DealModal
//                 showModal={showModal}
//                 handleClose={handleCloseModal}
//                 dealId={selectedDealId}
//                 dealData={selectedDealData}
//                 editDeal={editDeal}
//                 deals={deals}
//                 fetchOrganisation={fetchOrganisation}
//                 organisations={organisations}


//             />
//         </div>
//     );
// };

// export default OrderDealList;




// {/* <table className="table align-middle table-nowrap table-check table-list">
//                                         <thead className="table-sales-gradient">
//                                             <tr>
//                                                 <th style={{ width: '20px' }} className="align-middle">
//                                                     <div className="form-check font-size-16">
//                                                         <input className="form-check-input" type="checkbox" id="checkAll" />
//                                                         <label className="form-check-label" htmlFor="checkAll"></label>
//                                                     </div>
//                                                 </th>
//                                                 <th className="align-middle">#</th>
//                                                 <th className="align-middle">Name</th>
//                                                 <th className="align-middle">Organisation
//                                                     <div className="dropdown d-inline-block">
//                                                         <FaFilter
//                                                             className="ms-2 cursor-pointer filter-color"
//                                                             onClick={() => setFilterDropdown(filterDropdown === 'org' ? null : 'org')}
//                                                         />
//                                                         {filterDropdown === 'org' && (
//                                                             <ul className="dropdown-menu show">
//                                                                 <li><button className="dropdown-item" onClick={() => handleFilterChange('org', '')}>All</button></li>
//                                                                 {organisations.map((type) => (
//                                                                     <li key={type.id}>
//                                                                         <button className="dropdown-item" onClick={() => handleFilterChange('org', type.id)}>
//                                                                             {type.name}
//                                                                         </button>
//                                                                     </li>
//                                                                 ))}
//                                                             </ul>
//                                                         )}
//                                                     </div>
//                                                 </th>
//                                                 <th className="align-middle">Lead Source
//                                                     <div className="dropdown d-inline-block">
//                                                         <FaFilter
//                                                             className="ms-2 cursor-pointer filter-color"
//                                                             onClick={() => setFilterDropdown(filterDropdown === 'type' ? null : 'type')}
//                                                         />
//                                                         {filterDropdown === 'type' && (
//                                                             <ul className="dropdown-menu show">
//                                                                 <li>
//                                                                     <button className="dropdown-item" onClick={() => handleFilterChange('type', '')}>
//                                                                         All
//                                                                     </button>
//                                                                 </li>
//                                                                 <li>
//                                                                     <button className="dropdown-item" onClick={() => handleFilterChange('type', 'partner')}>
//                                                                         Partner
//                                                                     </button>
//                                                                 </li>
//                                                                 <li>
//                                                                     <button className="dropdown-item" onClick={() => handleFilterChange('type', 'consultant')}>
//                                                                         Consultant
//                                                                     </button>
//                                                                 </li>
//                                                                 <li>
//                                                                     <button className="dropdown-item" onClick={() => handleFilterChange('type', 'inside sale')}>
//                                                                         Inside Sales
//                                                                     </button>
//                                                                 </li>
//                                                                 <li>
//                                                                     <button className="dropdown-item" onClick={() => handleFilterChange('type', 'sales generated')}>
//                                                                         Sales Generated
//                                                                     </button>
//                                                                 </li>

//                                                             </ul>
//                                                         )}
//                                                     </div>
//                                                 </th>
//                                                 <th className="align-middle">Value</th>
//                                                 <th className="align-middle">Closed Date
//                                                     <div className="dropdown d-inline-block">
//                                                         <FaFilter
//                                                             className="ms-2 cursor-pointer filter-color"
//                                                             onClick={() => setDateFilterDropdown(!dateFilterDropdown)}
//                                                         />
//                                                         {dateFilterDropdown && (
//                                                             <div className="dropdown-menu show p-3" style={{ minWidth: '250px' }}>
//                                                                 <label className="form-label">From</label>
//                                                                 <input type="date" className="form-control mb-2" name="from" value={dateRange.from} onChange={handleDateChange} />

//                                                                 <label className="form-label">To</label>
//                                                                 <input type="date" className="form-control mb-2" name="to" value={dateRange.to} onChange={handleDateChange} />

//                                                                 <div className="text-end mt-3">
//                                                                     <button className="btn btn-primary btn-sm d-inline-block w-auto me-2" onClick={applyDateFilter}>
//                                                                         Apply
//                                                                     </button>
//                                                                     <button className="btn btn-secondary btn-sm d-inline-block w-auto" onClick={clearDateFilter}>
//                                                                         Clear
//                                                                     </button>
//                                                                 </div>
//                                                             </div>
//                                                         )}
//                                                     </div>
//                                                 </th>
//                                                 <th className="align-middle">Action</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {deals.length > 0 ? (
//                                                 deals.map((deal, index) => (
//                                                     <tr key={deal.id}>
//                                                         <td>
//                                                             <div className="form-check font-size-16">
//                                                                 <input
//                                                                     className="form-check-input"
//                                                                     type="checkbox"
//                                                                     id={`transactionCheck${index}`}
//                                                                 />
//                                                                 <label
//                                                                     className="form-check-label"
//                                                                     htmlFor={`transactionCheck${index}`}
//                                                                 ></label>
//                                                             </div>
//                                                         </td>
//                                                         <td>{index + 1}</td>
//                                                         <td>
//                                                             <Link to={`/deal/details/${deal.id}`} className="dropdown-item">
//                                                                 {deal.name}
//                                                             </Link>
//                                                         </td>
//                                                         <td>{deal.organisation ? deal.organisation.name : " "}</td>
//                                                         <td>{deal.lead_source}</td>
//                                                         <td>
//                                                             {Number(deal.value || 0).toLocaleString('en-US', {
//                                                                 minimumFractionDigits: 2,
//                                                                 maximumFractionDigits: 2
//                                                             })}
//                                                         </td>                                                        <td>{deal.closed_date}</td>
//                                                         <td>
//                                                             <div className="dropdown">
//                                                                 <i
//                                                                     className="mdi mdi-dots-horizontal font-size-18"
//                                                                     data-bs-toggle="dropdown"
//                                                                     aria-expanded="false"
//                                                                     style={{ cursor: "pointer" }}
//                                                                 ></i>
//                                                                 <ul className="dropdown-menu dropdown-menu-end font-size-14">
//                                                                     <li>
//                                                                         <Link to={`/deal/details/${deal.id}`} className="dropdown-item">
//                                                                             View Details
//                                                                         </Link>
//                                                                     </li>
//                                                                     <li>
//                                                                         <WithEditPermission>
//                                                                             <button
//                                                                                 className="dropdown-item"
//                                                                                 onClick={() => handleShowModal(deal.id)}

//                                                                             >
//                                                                                 Edit
//                                                                             </button>
//                                                                         </WithEditPermission>
//                                                                     </li>
//                                                                     <li>
//                                                                         <button
//                                                                             className="dropdown-item"
//                                                                             onClick={() => handleGenerateProformaInvoice(deal)}
//                                                                         >
//                                                                             Generate Proforma Invoice
//                                                                         </button>
//                                                                     </li>
//                                                                     {deal.quotation?.proforma_invoices?.length > 0 && (

//                                                                         <li>

//                                                                             <Link to={`/proformainvoice?quotation_id=${deal.quotation_id}`} className="dropdown-item">
//                                                                                 Proforma Invoice List
//                                                                             </Link>
//                                                                         </li>
//                                                                     )}
//                                                                     <li>
//                                                                         <button
//                                                                             className="dropdown-item"
//                                                                             onClick={() => handleVendorDropdownChange(deal)}
//                                                                         >
//                                                                             Generate Vendor PO
//                                                                         </button>
//                                                                     </li>
//                                                                     {deal.quotation?.purchase_order?.length > 0 && (

//                                                                         <li>
//                                                                             <Link to={`/purchase-order?quotation_id=${deal?.quotation_id}`} className="dropdown-item">
//                                                                                 Vendor PO Details
//                                                                             </Link>
//                                                                         </li>
//                                                                     )}
//                                                                     <li>
//                                                                         <WithDeletePermission>
//                                                                             <button
//                                                                                 className="dropdown-item"
//                                                                                 onClick={() => deleteDeal(deal.id)}

//                                                                             >
//                                                                                 Delete
//                                                                             </button>
//                                                                         </WithDeletePermission>
//                                                                     </li>
//                                                                 </ul>
//                                                             </div>
//                                                         </td>
//                                                     </tr>
//                                                 ))
//                                             ) : (
//                                                 <tr>
//                                                     <td colSpan="7" className="text-center">No deals found.</td>
//                                                 </tr>
//                                             )}
//                                         </tbody>
//                                     </table> */}
// {/* {showVendorsModal && (
//                                         <div className="modal show" style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
//                                             <div className="modal-dialog modal-dialog-centered">
//                                                 <div className="modal-content">
//                                                     <div className="modal-header">
//                                                         <h5 className="modal-title">Select Vendor for Purchase Order</h5>
//                                                         <button type="button" className="btn-close" onClick={handleCloseVendorsModal}></button>
//                                                     </div>
//                                                     <div className="modal-body">
//                                                         <div className="mb-4">

//                                                             <table className="table table-striped">
//                                                                 <thead>
//                                                                     <tr>
//                                                                         <th scope="col">Vendor Name</th>
//                                                                         <th scope="col">Action</th>
//                                                                     </tr>
//                                                                 </thead>
//                                                                 <tbody>
//                                                                     {selectedQuotationProducts.length > 0 ? (
//                                                                         selectedQuotationProducts.map((product, index) => {
//                                                                             const vendorName = vendorNames[product.product?.vendor_id];

//                                                                             return (
//                                                                                 <tr key={index}>
//                                                                                     <td>
//                                                                                         {vendorName ? (
//                                                                                             vendorName
//                                                                                         ) : (
//                                                                                             <span className="text-muted">Vendor not found</span>
//                                                                                         )}
//                                                                                     </td>
//                                                                                     <td>
//                                                                                         <button
//                                                                                             className="btn btn-primary btn-sm"
//                                                                                             onClick={() => handleCreatePurchaseOrder(product.product?.vendor_id)}
//                                                                                         >
//                                                                                             Create Purchase Order
//                                                                                         </button>
//                                                                                     </td>
//                                                                                 </tr>
//                                                                             );
//                                                                         })
//                                                                     ) : (
//                                                                         <tr>
//                                                                             <td colSpan="2" className="text-center text-muted">
//                                                                                 No vendors available for this quotation.
//                                                                             </td>
//                                                                         </tr>
//                                                                     )}
//                                                                 </tbody>
//                                                             </table>
//                                                         </div>
//                                                     </div>
//                                                     <div className="modal-footer">
//                                                         <button className="btn btn-secondary" onClick={handleCloseVendorsModal}>Close</button>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     )} */}








import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";
import DealModal from "./DealModal";
import withPermission from '../../../utils/withPermission';
import PurchaseOrderForm from '../../purchaseorder/PurchaseOrderForm';
import ProformaInvoiceModal from '../../ProformaInvoice/ProformaInvoiceModal';
import { FaFilter, FaChevronDown, FaChevronRight } from "react-icons/fa";
import { Offcanvas } from 'react-bootstrap';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import DirectOrderForm from './DirectOrderForm';
import RevenueBundleModal from './RevenueBundleModal';
import Select from 'react-select';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";

const OrderDealList = ({ projectId, isSubComponent = false }) => {
    const [deals, setDeals] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedDealId, setSelectedDealId] = useState(null);
    const [selectedDealData, setSelectedDealData] = useState(null);
    const [selectedProjectOrderId, setSelectedProjectOrderId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [searchQuery, setSearchQuery] = useState("");
    const [organisations, setOrganisation] = useState([]);
    const [showVendorsModal, setShowVendorsModal] = useState(false);
    const [selectedVendorId, setSelectedVendorId] = useState(null);
    const [proformainvoices, setPerformaInvoices] = useState("");
    const [showInvoiceDetails, setShowInvoiceDetails] = useState(null);
    const [showVendorDetails, setShowVendorDetails] = useState(false);
    const [vendorNames, setVendorNames] = useState({});
    const [poId, setPoId] = useState(null);
    const [activeTab, setActiveTab] = useState(0);
    const [expandedRows, setExpandedRows] = useState(new Set());
    const [showDirectOrderModal, setShowDirectOrderModal] = useState(false);
    const [showBundleModal, setShowBundleModal] = useState(false);
    const [selectedDealForBundle, setSelectedDealForBundle] = useState(null);

    const handleOpenBundleModal = (deal) => {
        setSelectedDealForBundle(deal);
        setShowBundleModal(true);
    };

    const handleCloseBundleModal = () => {
        setShowBundleModal(false);
        setSelectedDealForBundle(null);
    };

    const [selectedQuotationProducts, setSelectedQuotationProducts] = useState([]);
    const [showPurchaseOrderModal, setShowPurchaseOrderModal] = useState(false);
    const [vendors, setVendors] = useState([]);
    const [selectedQuotationId, setSelectedQuotationId] = useState(null);
    const [selectedQuotationData, setSelectedQuotationData] = useState(null);
    const [quotations, setQuotations] = useState([]);

    const WithCreatePermission = withPermission(({ children }) => children, ["deal-create"]);
    const WithEditPermission = withPermission(({ children }) => children, ["deal-edit"]);
    const WithDeletePermission = withPermission(({ children }) => children, ["deal-delete"]);

    const debounceTimeoutRef = useRef(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const [dateFilterDropdown, setDateFilterDropdown] = useState(false);
    const [dateRange, setDateRange] = useState({ from: '', to: '' });
    const [orgFilter, setorgFilter] = useState('');
    const [typeFilter, setTypeFilter] = useState('');
    const [filterDropdown, setFilterDropdown] = useState(null);
    const navigate = useNavigate();
    const [editingRevenueType, setEditingRevenueType] = useState(null);
    const [showProformaOffcanvas, setShowProformaOffcanvas] = useState(false);
    const [showOrderDetails, setShowOrderDetails] = useState(false);
    const [selectedOrderDetails, setSelectedOrderDetails] = useState(null);
    const [importLoading, setImportLoading] = useState(false);
    const [exportLoading, setExportLoading] = useState(false);
    const [issueDateFilter, setIssueDateFilter] = useState({ from: '', to: '' });
    const [clientFilter, setClientFilter] = useState('');
    const [clientFilterDropdown, setClientFilterDropdown] = useState(false);
    const [issueDateFilterDropdown, setIssueDateFilterDropdown] = useState(false);
    const [yearFilter, setYearFilter] = useState([]);
    const [projects, setProjects] = useState([]);
    const [clients, setClients] = useState([]);

    const [projectFilter, setProjectFilter] = useState(projectId || '');
    const [showPOAttachmentModal, setShowPOAttachmentModal] = useState(false);
    const [selectedPOForAttachment, setSelectedPOForAttachment] = useState(null);
    const [poAttachmentFile, setPOAttachmentFile] = useState(null);
    const [showPreviewModal, setShowPreviewModal] = useState(false); // Add this
    const [previewUrl, setPreviewUrl] = useState(''); // Add this
    const [previewLoading, setPreviewLoading] = useState(false); // Add this
    const [salesUsers, setSalesUsers] = useState([]);
    const [salesUserFilter, setSalesUserFilter] = useState('');
    const [userData, setUserData] = useState(null);
    useEffect(() => {
        const userInfo = JSON.parse(localStorage.getItem('user-info'));
        setUserData(userInfo);
        if (userInfo?.user?.roles?.some(r => r.data_scope === 'all' || r.name === 'superadmin')) {
            fetchSalesUsers();
        }
        fetchDeals(1);
        if (!projectId) fetchProjects();
    }, [projectId]);

    const fetchSalesUsers = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/users`, {
                params: { role: 'Inside Sales' },
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });
            setSalesUsers(response.data.users || []);
        } catch (error) {
            console.error("Error fetching sales users:", error);
        }
    };

    // const fetchDeals = async (page = 1) => {
    //     try {
    //         const backendUrl = process.env.REACT_APP_BACKEND_URL;
    //         const userInfo = JSON.parse(localStorage.getItem("user-info"));
    //         const origin = localStorage.getItem('user-origin');

    //         const token = userInfo?.token;
    //         let params = { page, stage: "order", };

    //         if (searchQuery) params.search = searchQuery;
    //         if (dateRange?.from) params.from_date = dateRange.from;
    //         if (dateRange?.to) params.to_date = dateRange.to;
    //         if (orgFilter) params.organisation_id = orgFilter;
    //         if (typeFilter) params.lead_source = typeFilter;

    //         const response = await axios.get(`${backendUrl}/api/deals`, {
    //             headers: {
    //                 Authorization: `Bearer ${token}`,
    //                 'Tenant-Origin': origin,
    //             },
    //             params,
    //         });

    //         const { data, current_page, last_page } = response.data.data;
    //         setDeals(data);
    //         setCurrentPage(current_page);
    //         setPageCount(last_page);
    //     } catch (error) {
    //         console.error("Error fetching deals:", error);
    //     }
    // };

    const fetchDeals = async (page = 1) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            let params = { page, stage: "order" };

            if (searchQuery) params.search = searchQuery;
            if (dateRange?.from) params.from_date = dateRange.from;
            if (dateRange?.to) params.to_date = dateRange.to;
            if (orgFilter) params.organisation_id = orgFilter;
            if (typeFilter) params.lead_source = typeFilter;

            // Add new filters
            if (issueDateFilter?.from) params.issue_start_date = issueDateFilter.from;
            if (issueDateFilter?.to) params.issue_end_date = issueDateFilter.to;
            if (clientFilter) params.client_id = clientFilter;
            if (projectFilter) params.project_id = projectFilter;
            if (yearFilter.length > 0) params.years = yearFilter.join(',');
            if (salesUserFilter) params.created_by = salesUserFilter;

            const response = await axios.get(`${backendUrl}/api/deals`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params,
            });

            const { data, current_page, last_page } = response.data.data;
            setDeals(data);
            setCurrentPage(current_page);
            setPageCount(last_page);
        } catch (error) {
            console.error("Error fetching deals:", error);
        }
    };
    const fetchQuotations = async (page = 1) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const url = `${backendUrl}/api/quotations?project_id=${selectedDealData?.project_id}&client_id=${selectedDealData?.client_id}&page=${page}`;
            const response = await axios.get(url, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            const quotationData = response.data.quotations || [];
            setQuotations(quotationData);

            const vendorNamesObj = {};
            const vendorsObj = {};

            quotationData.forEach(quotation => {
                quotation.product_item_details.forEach(product => {
                    const vendor = product.product?.vendor;
                    if (vendor && !vendorNamesObj[vendor.id]) {
                        vendorNamesObj[vendor.id] = vendor.name;
                        vendorsObj[vendor.id] = vendor.currency;
                    }
                });
            });

            setVendorNames(vendorNamesObj);
            setVendors(vendorsObj);
            setPageCount(response.data.meta?.total_pages || 1);
            setCurrentPage(page);
        } catch (error) {
            console.error('Error fetching quotations:', error);
        }
    };

    const fetchProjects = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/projects?all=true`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });
            const sortedClients = (response.data.Data || []).sort((a, b) => {
                const nameA = (a.name || a.company_name || a.first_name || '').toString().toLowerCase();
                const nameB = (b.name || b.company_name || b.first_name || '').toString().toLowerCase();
                return nameA.localeCompare(nameB);
            });

            setProjects(sortedClients); // ✅ Store only the selected client's projects

        } catch (error) {
            console.error('Error fetching projects:', error);
        }
    };

    const fetchOrganisation = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/organisation`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });

            const data = response.data.data;
            setOrganisation(data);
        } catch (error) {
            console.error(`Error fetching :`, error);
        }
    };
    const fetchClients = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/contacts?type=client`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });

            const sortedClients = (response.data.Data || []).sort((a, b) => {
                const nameA = (a.name || a.company_name || a.first_name || '').toString().toLowerCase();
                const nameB = (b.name || b.company_name || b.first_name || '').toString().toLowerCase();
                return nameA.localeCompare(nameB);
            });
            setClients(sortedClients);
        } catch (error) {
            console.error(`Error fetching clients:`, error);
        }
    };

    useEffect(() => {
        fetchClients();
    }, [salesUserFilter]);

    const handleSearchChange = (e) => setSearchQuery(e.target.value);

    const handlePageClick = (data) => {
        const selectedPage = data.selected + 1;
        fetchDeals(selectedPage);
    };

    const editDeal = async (contactId, updatedData) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            let endpoint = `${backendUrl}/api/deals/${contactId}`;
            if (selectedProjectOrderId) {
                endpoint = `${backendUrl}/api/project-orders/${selectedProjectOrderId}`;
            }

            const response = await axios.put(endpoint, updatedData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });
            const updatedDeal = response.data.Data;

            if (updatedDeal) {
                setDeals((prevDeal) =>
                    prevDeal.map((contact) => (contact.id === updatedDeal.id ? updatedDeal : contact))
                );
            } else {
                console.error('Update failed, no data returned.');
            }

            handleCloseModal();
            fetchDeals(currentPage);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: 'Updated Successfully!!',
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                }
            });
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors;
            } else
                console.error(`Error updating`, error);
        }
    };

    const deleteDeal = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const backendUrl = process.env.REACT_APP_BACKEND_URL;
                    const userInfo = JSON.parse(localStorage.getItem('user-info'));
                    const origin = localStorage.getItem('user-origin');
                    const token = userInfo?.token;

                    await axios.delete(`${backendUrl}/api/deals/${id}`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Tenant-Origin': origin,
                        },
                    });

                    setDeals(deals.filter((contact) => contact.id !== id));
                    Swal.fire(
                        "Deleted!",
                        "The deal has been deleted.",
                        "success"
                    );
                } catch (error) {
                    console.error('Error deleting deal:', error);
                    Swal.fire(
                        "Error!",
                        "Failed to delete deal. Please try again.",
                        "error"
                    );
                }
            }
        });
    };

    const handleShowModal = (contactId = null, poId = null) => {
        if (poId) {
            // Find the PO data from the deals list
            let foundPO = null;
            deals.forEach(deal => {
                const pos = deal.quotation?.project_orders || deal.quotation?.projectOrders || [];
                const po = pos.find(p => p.id === poId);
                if (po) foundPO = { ...po, parentDeal: deal };
            });
            
            if (foundPO) {
                setSelectedDealData(foundPO);
            }
            setSelectedProjectOrderId(poId);
        } else if (contactId) {
            const contactToEdit = deals.find((contact) => contact.id === contactId);
            if (contactToEdit) {
                setSelectedDealData(contactToEdit);
            }
            setSelectedProjectOrderId(null);
        } else {
            setSelectedDealData(null);
            setSelectedProjectOrderId(null);
        }
        setSelectedDealId(contactId);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedDealId(null);
        setSelectedDealData(null);
        setSelectedProjectOrderId(null);
    };

    const handleClosePurchaseOrderModal = () => {
        setShowPurchaseOrderModal(false);
        setSelectedVendorId(null);
    };

    const handleCloseVendorsModal = () => {
        setShowVendorsModal(false);
    };
    const handleViewOrderDetails = (deal) => {
        setSelectedOrderDetails(deal);
        setShowOrderDetails(true);
    };
    const handleIssueDateChange = (e) => {
        const { name, value } = e.target;
        setIssueDateFilter((prev) => ({ ...prev, [name]: value }));
    };

    const applyIssueDateFilter = () => {
        setIssueDateFilterDropdown(false);
        fetchDeals();
    };

    const clearIssueDateFilter = () => {
        setIssueDateFilter({ from: "", to: "" });
    };

    const handleClientFilter = (clientId) => {
        setClientFilter(clientId);
    };

    const clearClientFilter = () => {
        setClientFilter('');
    };

    const generateYears = () => {
        const currentYear = new Date().getFullYear();
        const years = [];
        // Show 10 years back and 5 years forward
        for (let i = currentYear - 10; i <= currentYear + 5; i++) {
            years.push(i.toString());
        }
        return years;
    };

    const yearOptions = generateYears().map(year => ({
        value: year,
        label: year
    }));

    const resetFilters = () => {
        setIssueDateFilter({ from: '', to: '' });
        setYearFilter([]);
        setClientFilter('');
        setDateRange({ from: '', to: '' });
        setorgFilter('');
        setTypeFilter('');
        setSearchQuery('');
        setProjectFilter('');
        setSalesUserFilter('');
        setFilterDropdown(null);
        fetchDeals(1);
    };

    const applyFilters = () => {
        fetchDeals(1);
    };

    const clearYearFilter = () => {
        setYearFilter([]);
    };

    const getUniqueClients = () => {
        const clients = [];
        const clientMap = new Map();

        deals.forEach(deal => {
            const client = deal.quotation?.project?.client;
            if (client && client.id && !clientMap.has(client.id)) {
                clientMap.set(client.id, client);
                clients.push(client);
            }
        });

        return clients;
    };

    const [showProformaModal, setShowProformaModal] = useState(false);
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // Validate file type
        const allowedTypes = [
            'application/pdf',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/jpeg',
            'image/jpg',
            'image/png'
        ];

        if (!allowedTypes.includes(file.type)) {
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Please upload a valid file (PDF, DOC, DOCX, JPG, PNG)',
                timer: 3000,
                showConfirmButton: false
            });
            return;
        }

        // Validate file size (max 10MB)
        const maxSize = 10 * 1024 * 1024;
        if (file.size > maxSize) {
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'File size must be less than 10MB',
                timer: 3000,
                showConfirmButton: false
            });
            return;
        }

        setPOAttachmentFile(file);
    };

    const handleVendorDropdownChange = (deal) => {
        const productsWithVendors = (deal?.quotation?.product_item_details ?? [])
            .filter(product => product.product?.vendor_id);

        if (productsWithVendors.length > 0) {
            const vendorNamesObj = {};
            const vendorsObj = {};

            productsWithVendors.forEach(product => {
                const vendor = product.product?.vendor;
                if (vendor && !vendorNamesObj[vendor.id]) {
                    vendorNamesObj[vendor.id] = vendor.name;
                    vendorsObj[vendor.id] = vendor.currency;
                }
            });

            setSelectedQuotationProducts(productsWithVendors);
            setVendorNames(vendorNamesObj);
            setVendors(vendorsObj);
            setSelectedQuotationId(deal.quotation.id);
            setSelectedQuotationData(deal.quotation);
            setShowVendorsModal(true);
        } else {
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'No vendors associated with products in this quotation.',
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                }
            });
        }
    };

    const handleGenerateProformaInvoice = (deal) => {
        const quotationDetails = deal?.quotation;
        console.log('quotaationData', quotationDetails);

        if (!quotationDetails || !quotationDetails.amount) {
            console.log("No valid quotation or amount found.");
            return;
        }

        const totalAmount = Number(quotationDetails.amount) || 0;

        if (totalAmount <= 0) {
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'warning',
                title: 'Quotation has no amount. Cannot create proforma invoice.',
                timer: 3000,
                showConfirmButton: false
            });
            return;
        }

        const totalReceived = (quotationDetails.proforma_invoices || []).reduce(
            (sum, inv) => sum + (Number(inv.amount) || 0),
            0
        );

        const balance = totalAmount - totalReceived;

        console.log({ totalAmount, totalReceived, balance });

        if (balance <= 0) {
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'warning',
                title: 'Cannot create proforma invoice. Balance amount is 0.',
                timer: 3000,
                showConfirmButton: false
            });
            return;
        }

        setShowProformaModal(true);
        // setSelectedQuotationData(quotationDetails);
        setSelectedQuotationData({
            ...quotationDetails,
            revenueSplit: splitOrderByRevenueType({ quotation: quotationDetails })
        });

    };

    const handleCloseProformaModal = () => {
        setShowProformaModal(false);
        setSelectedQuotationData(null);
    };

    const handleCreateProformaInvoice = (newInvoice) => {
        setQuotations(prevQuotations => {
            const updatedQuotations = prevQuotations.map(q =>
                q.id === newInvoice.quotation_id
                    ? { ...q, proforma_invoices: [...q.proforma_invoices, newInvoice] }
                    : q
            );
            console.log('Updated Quotations:', updatedQuotations);
            return updatedQuotations;
        });
    };

    const handleCreatePurchaseOrder = (vendorId) => {
        console.log('Vendor ID selected:', vendorId);
        setSelectedVendorId(vendorId);
        setShowPurchaseOrderModal(true);
        console.log('showPurchaseOrderModal set to:', true);
        setShowVendorsModal(false);
        setPoId(null);
    };

    const handleDateChange = (e) => {
        const { name, value } = e.target;
        setDateRange((prev) => ({ ...prev, [name]: value }));
    };

    const applyDateFilter = () => {
        setDateFilterDropdown(false);
        fetchDeals();
    };

    const clearDateFilter = () => {
        setDateRange({ from: "", to: "" });
    };

    const handleFilterChange = (filterType, value) => {
        if (filterType === 'org') setorgFilter(value);
        if (filterType === 'type') setTypeFilter(value);
        setFilterDropdown(null);
    };

    // Toggle row expansion
    const toggleRowExpansion = (dealId) => {
        const newExpandedRows = new Set(expandedRows);
        if (newExpandedRows.has(dealId)) {
            newExpandedRows.delete(dealId);
        } else {
            newExpandedRows.add(dealId);
        }
        setExpandedRows(newExpandedRows);
    };

    // Split order by revenue type
    // const splitOrderByRevenueType = (order) => {
    //     const subscriptionItems = [];
    //     const deploymentItems = [];
    //     let subscriptionTotal = 0;
    //     let deploymentTotal = 0;

    //     order.quotation?.product_item_details?.forEach(item => {
    //         const revenueType = item.product?.revenue_type;
    //         const itemTotal = parseFloat(item.subtotal) || 0;

    //         if (revenueType === 'deferred') {
    //             subscriptionItems.push(item);
    //             subscriptionTotal += itemTotal;
    //         } else if (revenueType === 'immediate') {
    //             deploymentItems.push(item);
    //             deploymentTotal += itemTotal;
    //         }
    //     });

    //     return {
    //         subscription: {
    //             items: subscriptionItems,
    //             total: subscriptionTotal,
    //             count: subscriptionItems.length
    //         },
    //         deployment: {
    //             items: deploymentItems,
    //             total: deploymentTotal,
    //             count: deploymentItems.length
    //         }
    //     };
    // };

    // Split order by revenue type
    // const splitOrderByRevenueType = (order) => {
    //     const subscriptionItems = [];
    //     const deploymentItems = [];
    //     let subscriptionTotal = 0;
    //     let deploymentTotal = 0;

    //     const subscriptionPeriod = order.quotation?.subscription_period || 1; // Default 1 month

    //     order.quotation?.product_item_details?.forEach(item => {
    //         const revenueType = item.product?.revenue_type;
    //         const itemTotal = parseFloat(item.subtotal) || 0;

    //         if (revenueType === 'deferred') {
    //             subscriptionItems.push({
    //                 ...item,
    //                 amountPerMonth: itemTotal,
    //                 totalAmount: itemTotal * subscriptionPeriod
    //             });
    //             subscriptionTotal += itemTotal * subscriptionPeriod;
    //         } else if (revenueType === 'immediate') {
    //             deploymentItems.push(item);
    //             deploymentTotal += itemTotal;
    //         }
    //     });

    //     return {
    //         subscription: {
    //             items: subscriptionItems,
    //             total: subscriptionTotal,       // total for all months
    //             perMonthTotal: subscriptionTotal / (subscriptionPeriod || 1), // optional
    //             count: subscriptionItems.length
    //         },
    //         deployment: {
    //             items: deploymentItems,
    //             total: deploymentTotal,
    //             count: deploymentItems.length
    //         }
    //     };
    // };

    // Split order by revenue type using actual quotation amounts
    // const splitOrderByRevenueType = (order) => {
    //     const quotation = order.quotation;

    //     // Get totals from quotation data
    //     const totalAmountWithSubscription = parseFloat(quotation?.total_amount_with_subscription) || 0;
    //     const deploymentAmount = parseFloat(quotation?.deplyment_amount) || 0;

    //     // If we have the actual amounts from quotation, use them
    //     if (totalAmountWithSubscription > 0 || deploymentAmount > 0) {
    //         const subscriptionItems = [];
    //         const deploymentItems = [];

    //         // Distribute products based on their characteristics
    //         quotation?.product_item_details?.forEach(item => {
    //             const product = item.product;
    //             const isServiceProduct = product?.license_type?.toLowerCase() === 'service';

    //             if (isServiceProduct) {
    //                 deploymentItems.push(item);
    //             } else {
    //                 subscriptionItems.push(item);
    //             }
    //         });

    //         return {
    //             subscription: {
    //                 items: subscriptionItems,
    //                 total: totalAmountWithSubscription,
    //                 perMonthTotal: totalAmountWithSubscription / (quotation?.subscription_period || 1),
    //                 count: subscriptionItems.length
    //             },
    //             deployment: {
    //                 items: deploymentItems,
    //                 total: deploymentAmount,
    //                 count: deploymentItems.length
    //             }
    //         };
    //     }

    //     // Fallback to calculation based on pricing data
    //     const subscriptionItems = [];
    //     const deploymentItems = [];
    //     let subscriptionTotal = 0;
    //     let deploymentTotal = 0;

    //     const subscriptionPeriod = quotation?.subscription_period || 1;
    //     const selectedLicenseType = quotation?.license_type_name?.toLowerCase();

    //     quotation?.product_item_details?.forEach(item => {
    //         const product = item.product;
    //         const pricings = product?.pricings || [];

    //         // Find matching pricing
    //         let matchingPricing = null;
    //         if (selectedLicenseType && pricings.length > 0) {
    //             matchingPricing = pricings.find(p =>
    //                 p.license_model?.toLowerCase() === selectedLicenseType
    //             );
    //         }
    //         if (!matchingPricing && pricings.length > 0) {
    //             matchingPricing = pricings[0];
    //         }

    //         const isServiceProduct = product?.license_type?.toLowerCase() === 'service';

    //         if (matchingPricing) {
    //             const subscriptionAmount = parseFloat(matchingPricing.price) || 0;
    //             const deploymentAmount = parseFloat(matchingPricing.deployment_cost) || 0;
    //             const itemQuantity = parseFloat(item.quantity) || 1;

    //             if (isServiceProduct) {
    //                 // Service products go to deployment
    //                 const itemDeploymentTotal = deploymentAmount * itemQuantity;
    //                 if (itemDeploymentTotal > 0) {
    //                     deploymentItems.push({
    //                         ...item,
    //                         deploymentAmount: itemDeploymentTotal,
    //                         totalAmount: itemDeploymentTotal
    //                     });
    //                     deploymentTotal += itemDeploymentTotal;
    //                 }
    //             } else {
    //                 // Regular products: both subscription and deployment
    //                 const itemSubscriptionTotal = subscriptionAmount * itemQuantity;
    //                 const itemDeploymentTotal = deploymentAmount * itemQuantity;

    //                 if (itemSubscriptionTotal > 0) {
    //                     subscriptionItems.push({
    //                         ...item,
    //                         amountPerMonth: itemSubscriptionTotal,
    //                         totalAmount: itemSubscriptionTotal * subscriptionPeriod
    //                     });
    //                     subscriptionTotal += itemSubscriptionTotal * subscriptionPeriod;
    //                 }

    //                 if (itemDeploymentTotal > 0) {
    //                     deploymentItems.push({
    //                         ...item,
    //                         deploymentAmount: itemDeploymentTotal,
    //                         totalAmount: itemDeploymentTotal
    //                     });
    //                     deploymentTotal += itemDeploymentTotal;
    //                 }
    //             }
    //         } else {
    //             // Fallback
    //             const itemTotal = parseFloat(item.subtotal) || 0;
    //             if (isServiceProduct) {
    //                 deploymentItems.push({
    //                     ...item,
    //                     deploymentAmount: itemTotal,
    //                     totalAmount: itemTotal
    //                 });
    //                 deploymentTotal += itemTotal;
    //             } else {
    //                 subscriptionItems.push({
    //                     ...item,
    //                     amountPerMonth: itemTotal,
    //                     totalAmount: itemTotal * subscriptionPeriod
    //                 });
    //                 subscriptionTotal += itemTotal * subscriptionPeriod;
    //             }
    //         }
    //     });

    //     return {
    //         subscription: {
    //             items: subscriptionItems,
    //             total: subscriptionTotal,
    //             perMonthTotal: subscriptionTotal / (subscriptionPeriod || 1),
    //             count: subscriptionItems.length
    //         },
    //         deployment: {
    //             items: deploymentItems,
    //             total: deploymentTotal,
    //             count: deploymentItems.length
    //         }
    //     };
    // };


    // Fixed revenue split function
    const splitOrderByRevenueType = (order) => {
        const quotation = order.quotation;

        // For direct orders or ProjectOrders, use the cost fields directly
        if (order?.is_direct_order === true || order?.source === 'project_order') {
            return {
                subscription: {
                    items: [],
                    total: Number(order?.recurring_cost || 0),
                    perMonthTotal: Number(order?.recurring_cost || 0),
                    count: order?.recurring_cost > 0 ? 1 : 0
                },
                deployment: {
                    items: [],
                    total: Number(order?.one_time_cost || 0),
                    count: order?.one_time_cost > 0 ? 1 : 0
                }
            };
        }

        // For regular orders, use quotation data with fallbacks
        const totalAmountWithSubscription = parseFloat(quotation?.total_amount_with_subscription) || 0;
        const deploymentAmount = parseFloat(quotation?.deplyment_amount) || 0;

        // If we have explicit amounts, use them
        if (totalAmountWithSubscription > 0 || deploymentAmount > 0) {
            const subscriptionItems = [];
            const deploymentItems = [];

            // Distribute products if available
            quotation?.product_item_details?.forEach(item => {
                const product = item.product;
                const isServiceProduct = product?.license_type?.toLowerCase() === 'service';

                if (isServiceProduct) {
                    deploymentItems.push(item);
                } else {
                    subscriptionItems.push(item);
                }
            });

            return {
                subscription: {
                    items: subscriptionItems,
                    total: totalAmountWithSubscription,
                    perMonthTotal: totalAmountWithSubscription / (quotation?.subscription_period || 1),
                    count: subscriptionItems.length
                },
                deployment: {
                    items: deploymentItems,
                    total: deploymentAmount,
                    count: deploymentItems.length
                }
            };
        }

        // Fallback: calculate from product items
        let subscriptionTotal = 0;
        let deploymentTotal = 0;
        const subscriptionItems = [];
        const deploymentItems = [];

        quotation?.product_item_details?.forEach(item => {
            const product = item.product;
            const itemTotal = parseFloat(item.subtotal) || 0;

            if (product?.revenue_type === 'deferred' || product?.license_type?.toLowerCase() !== 'service') {
                subscriptionItems.push(item);
                subscriptionTotal += itemTotal;
            } else {
                deploymentItems.push(item);
                deploymentTotal += itemTotal;
            }
        });

        return {
            subscription: {
                items: subscriptionItems,
                total: subscriptionTotal,
                perMonthTotal: subscriptionTotal / (quotation?.subscription_period || 1),
                count: subscriptionItems.length
            },
            deployment: {
                items: deploymentItems,
                total: deploymentTotal,
                count: deploymentItems.length
            }
        };
    };
    // Filter orders based on active tab
    // Filter orders based on active tab
    const getFilteredOrders = () => {
        if (activeTab === 0) return deals; // All orders

        const filteredDeals = deals.filter(order => {
            const revenueSplit = splitOrderByRevenueType(order);

            if (activeTab === 1) { // Subscription tab
                // Changed from count > 0 to total > 0 to be more inclusive
                return revenueSplit.subscription.total > 0;
            }

            if (activeTab === 2) { // Deployment tab
                // Changed from count > 0 to total > 0 to be more inclusive
                return revenueSplit.deployment.total > 0;
            }

            return true;
        });

        return filteredDeals;
    };
    // Handle PO Attachment
    const handlePOAttachment = (deal) => {
        setSelectedPOForAttachment(deal);
        setShowPOAttachmentModal(true);
        setPOAttachmentFile(null);
    };

    // Upload attachment
    const handleUploadAttachment = async () => {
        if (!poAttachmentFile || !selectedPOForAttachment) return;

        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const formData = new FormData();
            formData.append('po_attachment', poAttachmentFile);

            await axios.post(
                `${backendUrl}/api/deals/upload-attachment/${selectedPOForAttachment.id}`,
                formData,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Tenant-Origin': origin,
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: 'Attachment uploaded successfully!',
                timer: 3000,
                showConfirmButton: false
            });

            setShowPOAttachmentModal(false);
            setPOAttachmentFile(null);
            fetchDeals(currentPage);

        } catch (error) {
            console.error('Upload error:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Failed to upload attachment',
                timer: 3000,
                showConfirmButton: false
            });
        }
    };


    // Delete attachment
    const handleDeleteAttachment = async (attachmentId) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            await axios.delete(`${backendUrl}/api/deals/attachments/${attachmentId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                }
            });

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: 'Attachment deleted successfully!',
                timer: 3000,
                showConfirmButton: false
            });

            fetchDeals(currentPage); // Refresh the list

        } catch (error) {
            console.error('Delete error:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Failed to delete attachment',
                timer: 3000,
                showConfirmButton: false
            });
        }
    };

    const OrderTableRow = ({ deal, index }) => {
        const revenueSplit = splitOrderByRevenueType(deal);
        if (activeTab === 1 &&
            (
                revenueSplit.subscription.total > 0 ||
                (
                    deal?.is_direct_order === true &&
                    (Number(deal?.recurring_cost) > 0)
                )
            )
        ) {
            return (
                <tr key={`${deal.id}-subscription`}>
                    <td>
                        <div className="form-check font-size-16">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id={`transactionCheck${index}-subscription`}
                            />
                            <label
                                className="form-check-label"
                                htmlFor={`transactionCheck${index}-subscription`}
                            ></label>
                        </div>
                    </td>
                    <td>{index + 1}</td>
                    <td>


                        {(() => {
                            const rawDate =
                                deal?.issue_date;

                            if (!rawDate) return "-";

                            const d = new Date(rawDate);
                            const day = String(d.getDate()).padStart(2, "0");
                            const month = String(d.getMonth() + 1).padStart(2, "0");
                            const year = d.getFullYear();

                            return `${day}-${month}-${year}`;
                        })()}
                    </td>
                    <td>
                        <span style={{ cursor: 'default', textDecoration: 'none' }}>
                            {deal.project?.name || deal.quotation?.project?.name || deal?.name}
                        </span>
                        {deal.unbundled_items && deal.unbundled_items.length > 0 && (
                            <span className="badge bg-info ms-2" style={{ fontSize: '0.75rem', padding: '0.35em 0.5em' }}>Bundled</span>
                        )}
                    </td>
                    <td>{deal.client?.name || deal.quotation?.project?.client?.name}</td>
                    <td>
                        {(
                            deal?.is_direct_order === true
                                ? Number(deal?.recurring_cost ?? 0)
                                : Number(revenueSplit?.subscription?.total ?? 0)
                        ).toLocaleString('en-US', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })}
                    </td>

                    <td>
                        {(() => {
                            const date = deal.source === 'project_order'
                                ? deal.subscription_start_date
                                : (deal.subscription_start_date || deal.project?.subscription_start_date || deal.quotation?.project?.subscription_start_date);
                            
                            if (!date) return '-';
                            try {
                                return typeof date === 'string' && date.includes('T') ? date.split('T')[0] : date;
                            } catch (e) { return date; }
                        })()}
                    </td>
                    <td>
                        {(() => {
                            const date = deal.source === 'project_order'
                                ? deal.subscription_end_date
                                : (deal.subscription_end_date || deal.vendor_subscription_end_dates || deal.project?.vendor_subscription_end_dates || deal.quotation?.project?.vendor_subscription_end_dates);
                            
                            if (!date) return '-';
                            try {
                                return typeof date === 'string' && date.includes('T') ? date.split('T')[0] : date;
                            } catch (e) { return date; }
                        })()}
                    </td>
                    <td>
                        {/* Simplified actions for subscription items */}
                        <div className="dropdown">
                            <i
                                className="mdi mdi-dots-horizontal font-size-18"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                style={{ cursor: "pointer" }}
                            ></i>
                            <ul className="dropdown-menu dropdown-menu-end font-size-14">
                                <li>
                                    <button
                                        className="dropdown-item"
                                        onClick={() => handleViewOrderDetails(deal)}
                                    >
                                        View Details
                                    </button>
                                </li>
                                <li>
                                    <WithEditPermission>
                                        <button
                                            className="dropdown-item"
                                            onClick={() => {
                                                setEditingRevenueType('subscription');
                                                handleShowModal(deal.id);
                                            }}
                                        >
                                            Edit Subscription
                                        </button>
                                    </WithEditPermission>
                                </li>
                            </ul>
                        </div>
                    </td>
                </tr>
            );
        }
        if (activeTab === 2 &&
            (
                revenueSplit.deployment.total > 0 ||
                (
                    deal?.is_direct_order === true &&
                    (Number(deal?.one_time_cost) > 0)
                )
            )) {
            return (
                <tr key={`${deal.id}-deployment`}>
                    <td>
                        <div className="form-check font-size-16">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id={`transactionCheck${index}-deployment`}
                            />
                            <label
                                className="form-check-label"
                                htmlFor={`transactionCheck${index}-deployment`}
                            ></label>
                        </div>
                    </td>
                    <td>{index + 1}</td>
                    <td>


                        {(() => {
                            const rawDate =
                                deal?.issue_date;

                            if (!rawDate) return "-";

                            const d = new Date(rawDate);
                            const day = String(d.getDate()).padStart(2, "0");
                            const month = String(d.getMonth() + 1).padStart(2, "0");
                            const year = d.getFullYear();

                            return `${day}-${month}-${year}`;
                        })()}
                    </td>

                    <td>
                        <span style={{ cursor: 'default', textDecoration: 'none' }}>
                            {deal.project?.name || deal.quotation?.project?.name || deal.name}
                        </span>
                    </td>
                    <td>{deal.client?.name || deal.quotation?.project?.client?.name}</td>
                    <td>
                        {(
                            deal?.is_direct_order === true
                                ? Number(deal?.one_time_cost ?? 0)
                                : Number(revenueSplit?.deployment?.total ?? 0)
                        ).toLocaleString('en-US', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })}
                    </td>
                    <td>
                        {(() => {
                            const date = deal.source === 'project_order'
                                ? deal.deployment_start_date
                                : (deal.deployment_start_date || deal.project?.deployment_start_date || deal.quotation?.project?.deployment_start_date);
                            
                            if (!date) return '-';
                            try {
                                return typeof date === 'string' && date.includes('T') ? date.split('T')[0] : date;
                            } catch (e) { return date; }
                        })()}
                    </td>
                    <td>
                        {(() => {
                            const date = deal.source === 'project_order'
                                ? deal.deployment_end_date
                                : (deal.deployment_end_date || deal.project?.deployment_end_date || deal.quotation?.project?.deployment_end_date);
                            
                            if (!date) return '-';
                            try {
                                return typeof date === 'string' && date.includes('T') ? date.split('T')[0] : date;
                            } catch (e) { return date; }
                        })()}
                    </td>
                    <td>
                        <div className="dropdown">
                            <i
                                className="mdi mdi-dots-horizontal font-size-18"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                style={{ cursor: "pointer" }}
                            ></i>
                            <ul className="dropdown-menu dropdown-menu-end font-size-14">
                                <li>
                                    <button
                                        className="dropdown-item"
                                        onClick={() => handleViewOrderDetails(deal)}
                                    >
                                        View Details
                                    </button>
                                </li>
                                <li>
                                    <WithEditPermission>
                                        <button
                                            className="dropdown-item"
                                            onClick={() => {
                                                setEditingRevenueType('deployment');
                                                if (deal.source === 'project_order') {
                                                    handleShowModal(deal.parentDeal.id, deal.id);
                                                } else {
                                                    handleShowModal(deal.id);
                                                }
                                            }}
                                        >
                                            Edit Deployment
                                        </button>
                                    </WithEditPermission>
                                </li>
                            </ul>
                        </div>
                    </td>
                </tr>
            );
        }
        if (activeTab === 0) {
            const isExpanded = expandedRows.has(deal.source === 'project_order' ? `po-${deal.id}` : deal.id);

            return (
                <>
                    {/* Main Order Row */}
                    <tr key={`${deal.source || 'deal'}-${deal.id}`}>
                        <td>
                            <div className="form-check font-size-16">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`transactionCheck${index}`}
                                />
                                <label
                                    className="form-check-label"
                                    htmlFor={`transactionCheck${index}`}
                                ></label>
                            </div>
                        </td>
                        <td>{index + 1}</td>
                        <td>
                            <span
                                className="cursor-pointer"
                                onClick={() => toggleRowExpansion(deal.source === 'project_order' ? `po-${deal.id}` : deal.id)}
                                style={{ cursor: 'pointer', textDecoration: 'none' }}
                            >
                                {(() => {
                                    const rawDate =
                                        deal?.issue_date;

                                    if (!rawDate) return "-";

                                    const d = new Date(rawDate);
                                    const day = String(d.getDate()).padStart(2, "0");
                                    const month = String(d.getMonth() + 1).padStart(2, "0");
                                    const year = d.getFullYear();

                                    return `${day}-${month}-${year}`;
                                })()}
                            </span>
                        </td>
                        <td>{deal.po_number || deal.external_id || '-'}</td>

                        <td>
                            <span
                                className="cursor-pointer"
                                onClick={() => toggleRowExpansion(deal.source === 'project_order' ? `po-${deal.id}` : deal.id)}
                                style={{ cursor: 'pointer', textDecoration: 'none' }}
                            >
                                {deal.name || deal.project?.name || deal?.quotation?.project?.name}
                            </span>
                        </td>
                        <td>{deal.client?.name || deal.quotation?.project?.client?.name || deal.parentDeal?.client?.name || deal.parentDeal?.quotation?.project?.client?.name}</td>
                        <td>
                            {Number(deal.total_value || deal.po_value || deal?.quotation?.amount || 0).toLocaleString('en-US', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}
                        </td>

                        <td>
                            {(() => {
                                const date = deal.source === 'project_order'
                                    ? (deal.subscription_start_date || deal.deployment_start_date)
                                    : (deal.subscription_start_date || deal.quotation?.project?.subscription_start_date);
                                
                                if (!date) return '-';
                                try {
                                    return new Date(date).toISOString().split('T')[0];
                                } catch (e) {
                                    return date;
                                }
                            })()}
                        </td>

                        <td>
                            {(() => {
                                const date = deal.source === 'project_order'
                                    ? (deal.subscription_end_date || deal.deployment_end_date)
                                    : (deal.subscription_end_date || deal.vendor_subscription_end_dates || deal.quotation?.project?.vendor_subscription_end_dates || deal.deployment_end_date || deal.quotation?.project?.deployment_end_date);
                                
                                if (!date) return '-';
                                try {
                                    if (typeof date === 'string' && date.includes('T')) {
                                        return date.split('T')[0];
                                    }
                                    return date;
                                } catch (e) {
                                    return date;
                                }
                            })()}
                        </td>
                        <td>
                            {/* Action Dropdown */}
                            <div className="dropdown">
                                <i
                                    className="mdi mdi-dots-horizontal font-size-18"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                    style={{ cursor: "pointer" }}
                                ></i>
                                <ul className="dropdown-menu dropdown-menu-end font-size-14">
                                    <li>
                                        <button
                                            className="dropdown-item"
                                            onClick={() => handleViewOrderDetails(deal)}
                                        >
                                            View Details
                                        </button>
                                    </li>
                                    <li>
                                        <WithEditPermission>
                                            <button
                                                className="dropdown-item"
                                                onClick={() => {
                                                    if (deal.source === 'project_order') {
                                                        handleShowModal(deal.parentDeal.id, deal.id);
                                                    } else {
                                                        handleShowModal(deal.id);
                                                    }
                                                }}
                                            >
                                                Edit
                                            </button>
                                        </WithEditPermission>
                                    </li>
                                    <li>
                                        <button
                                            className="dropdown-item"
                                            onClick={() => handleGenerateProformaInvoice(deal)}
                                        >
                                            Generate Proforma Invoice
                                        </button>
                                    </li>
                                    {deal.quotation?.proforma_invoices?.length > 0 && (
                                        <li>
                                            <Link to={`/proformainvoice?quotation_id=${deal.quotation_id}`} className="dropdown-item">
                                                Proforma Invoice List
                                            </Link>
                                        </li>
                                    )}
                                    <li>
                                        <button
                                            className="dropdown-item"
                                            onClick={() => handleVendorDropdownChange(deal)}
                                        >
                                            Generate Vendor PO
                                        </button>
                                    </li>
                                    {deal.quotation?.purchase_order?.length > 0 && (
                                        <li>
                                            <Link to={`/purchase-order?quotation_id=${deal?.quotation_id}`} className="dropdown-item">
                                                Vendor PO Details
                                            </Link>
                                        </li>
                                    )}
                                    <li>
                                        <WithDeletePermission>
                                            <button
                                                className="dropdown-item"
                                                onClick={() => deleteDeal(deal.id)}
                                            >
                                                Delete
                                            </button>
                                        </WithDeletePermission>
                                    </li>
                                    <li>
                                        <button
                                            className="dropdown-item"
                                            onClick={() => handlePOAttachment(deal)}
                                        >
                                            <i className="mdi mdi-paperclip me-1"></i>
                                            PO Attachment
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            className="dropdown-item"
                                            onClick={() => handleOpenBundleModal(deal)}
                                        >
                                            <i className="mdi mdi-layers-outline me-1"></i>
                                            Bundle / Unbundle Revenue
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </td>
                    </tr>

                    {/* Expanded Child Rows */}
                    {isExpanded && (
                        <>
                            {revenueSplit.deployment.total > 0 && (
                                <tr className="bg-light">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td className="fw-bold">
                                        {deal.project?.name || deal.name} (Deployment)
                                    </td>
                                    <td>{deal.client?.name || deal.quotation?.project?.client?.name}</td>
                                    <td>
                                        {(
                                            deal?.is_direct_order === true
                                                ? Number(deal?.one_time_cost ?? 0)
                                                : Number(revenueSplit?.deployment?.total ?? 0)
                                        ).toLocaleString('en-US', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        })}
                                    </td>
                                    <td>{deal.source === 'project_order' ? (deal.deployment_start_date || '-') : (deal.deployment_start_date || deal.project?.deployment_start_date || deal.quotation?.project?.deployment_start_date || '-')}</td>
                                    <td>{deal.source === 'project_order' ? (deal.deployment_end_date || '-') : (deal.deployment_end_date || deal.project?.deployment_end_date || deal.quotation?.project?.deployment_end_date || '-')}</td>
                                    <td>
                                        <div className="dropdown">
                                            <i
                                                className="mdi mdi-dots-horizontal font-size-18"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                                style={{ cursor: "pointer" }}
                                            ></i>
                                            <ul className="dropdown-menu dropdown-menu-end font-size-14">

                                                <li>
                                                    <WithEditPermission>
                                                        <button
                                                            className="dropdown-item"
                                                            onClick={() => {
                                                                setEditingRevenueType('deployment'); // or 'subscription'
                                                                handleShowModal(deal.id);
                                                            }}
                                                        >
                                                            Edit
                                                        </button>
                                                    </WithEditPermission>
                                                </li>

                                            </ul>
                                        </div>
                                    </td>
                                </tr>
                            )}

                            {revenueSplit.subscription.total > 0 && (
                                <tr className="bg-light">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td className="fw-bold">
                                        {deal.project?.name || deal.name} (Subscription)
                                    </td>
                                    <td>{deal.client?.name || deal.quotation?.project?.client?.name}</td>
                                    <td>
                                        {(
                                            deal?.is_direct_order === true
                                                ? Number(deal?.recurring_cost ?? 0)
                                                : Number(revenueSplit?.subscription?.total ?? 0)
                                        ).toLocaleString('en-US', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        })}
                                    </td>
                                    <td>{deal.source === 'project_order' ? (deal.subscription_start_date || '-') : (deal.subscription_start_date || deal.project?.subscription_start_date || deal.quotation?.project?.subscription_start_date || '-')}</td>
                                    <td>{deal.source === 'project_order' ? (deal.subscription_end_date || '-') : (deal.subscription_end_date || deal.vendor_subscription_end_dates || deal.project?.subscription_end_date || deal.quotation?.project?.subscription_end_date || '-')}</td>
                                    <td>
                                        <div className="dropdown">
                                            <i
                                                className="mdi mdi-dots-horizontal font-size-18"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                                style={{ cursor: "pointer" }}
                                            ></i>
                                            <ul className="dropdown-menu dropdown-menu-end font-size-14">

                                                <li>
                                                    <WithEditPermission>
                                                        <button
                                                            className="dropdown-item"
                                                            onClick={() => {
                                                                setEditingRevenueType('subscription'); // or 'subscription'
                                                                if (deal.source === 'project_order') {
                                                                    handleShowModal(deal.parentDeal.id, deal.id);
                                                                } else {
                                                                    handleShowModal(deal.id);
                                                                }
                                                            }}
                                                        >
                                                            Edit
                                                        </button>
                                                    </WithEditPermission>
                                                </li>

                                            </ul>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </>
                    )}
                </>
            );
        }


        return null;
    };


    // Order Table Component
    const OrderTable = ({ deals }) => {
        // Flatten deals and their nested project_orders
        let flattenedItems = [];
        deals.forEach(deal => {
            // Add the main deal
            flattenedItems.push({ ...deal, source: 'deal' });
            
            // Add any project_orders
            const pos = deal.quotation?.project_orders || deal.quotation?.projectOrders || [];
            pos.forEach(po => {
                // To avoid duplication, check if this PO is already represented by the main Deal row
                // We compare po_number. If they are the same, the main row already shows this order.
                if (deal.po_number && po.po_number && deal.po_number.trim().toLowerCase() === po.po_number.trim().toLowerCase()) {
                    return; 
                }
                flattenedItems.push({ ...po, source: 'project_order', parentDeal: deal });
            });
        });

        // If there's a search query, filter the flattened items to show only relevant ones
        if (searchQuery) {
            const query = searchQuery.toLowerCase().trim();
            flattenedItems = flattenedItems.filter(item => {
                const poNumber = (item.po_number || item.external_id || '').toString().toLowerCase();
                const projectName = (item.name || item.project?.name || item.parentDeal?.name || '').toString().toLowerCase();
                const clientName = (item.client?.name || 
                                   item.quotation?.project?.client?.name || 
                                   item.parentDeal?.client?.name || 
                                   item.parentDeal?.quotation?.project?.client?.name || '').toString().toLowerCase();
                
                return poNumber.includes(query) || projectName.includes(query) || clientName.includes(query);
            });
        }

        return (
            <div>
                <table className="table align-middle table-nowrap table-check table-list">
                    <thead className="table-sales-gradient">
                        <tr>
                            <th style={{ width: '20px' }} className="align-middle">
                                <div className="form-check font-size-16">
                                    <input className="form-check-input" type="checkbox" id="checkAll" />
                                    <label className="form-check-label" htmlFor="checkAll"></label>
                                </div>
                            </th>
                            <th className="align-middle">#</th>
                            <th className="align-middle">Issue Date</th>
                            <th className="align-middle">Order #</th>
                            <th className="align-middle">Project</th>
                            <th className="align-middle">Client</th>
                            <th className="align-middle">Total Amount</th>
                            <th className="align-middle">Start Date</th>
                            <th className="align-middle">End Date</th>
                            <th className="align-middle">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {flattenedItems.length > 0 ? (
                            flattenedItems.map((item, index) => (
                                <OrderTableRow key={`${item.source || 'deal'}-${item.id}-${index}`} deal={item} index={index} />
                            ))
                        ) : (
                            <tr>
                                <td colSpan="9" className="text-center">No orders found.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        );
    };



    // Add these functions for import/export
    const handleExport = async () => {
        try {
            setExportLoading(true);
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            let params = { stage: "order" };
            if (searchQuery) params.search = searchQuery;
            if (dateRange?.from) params.from_date = dateRange.from;
            if (dateRange?.to) params.to_date = dateRange.to;
            if (orgFilter) params.organisation_id = orgFilter;

            const response = await axios.get(`${backendUrl}/api/deals/export`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params,
                responseType: 'blob'
            });

            // Create download link
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `orders_${new Date().toISOString().split('T')[0]}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: 'Orders exported successfully!',
                timer: 3000,
                showConfirmButton: false
            });

        } catch (error) {
            console.error('Export error:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Failed to export orders',
                timer: 3000,
                showConfirmButton: false
            });
        } finally {
            setExportLoading(false);
        }
    };



    const handleImport = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        // Validate file type
        const validTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/csv'];
        if (!validTypes.includes(file.type)) {
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Please select a valid Excel or CSV file',
                timer: 3000,
                showConfirmButton: false
            });
            return;
        }

        try {
            setImportLoading(true);
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const formData = new FormData();
            formData.append('file', file);

            const response = await axios.post(`${backendUrl}/api/deals/import`, formData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                    'Content-Type': 'multipart/form-data'
                }
            });

            const result = response.data;

            // Show success summary
            let successParts = [];
            if (result.imported_count > 0) {
                successParts.push(`${result.imported_count} new orders imported`);
            }
            if (result.updated_count > 0) {
                successParts.push(`${result.updated_count} orders updated`);
            }

            if (successParts.length > 0) {
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'success',
                    title: successParts.join(', '),
                    timer: 4000,
                    showConfirmButton: false
                });
            }

            // Show detailed warnings for skipped rows
            if (result.skipped_count > 0 && result.skipped_rows && result.skipped_rows.length > 0) {
                // Group errors by type for better display
                const errorsByType = {};
                result.skipped_rows.forEach(error => {
                    const rowMatch = error.match(/Row (\d+):/);
                    const rowNumber = rowMatch ? rowMatch[1] : 'Unknown';

                    if (!errorsByType[rowNumber]) {
                        errorsByType[rowNumber] = [];
                    }
                    errorsByType[rowNumber].push(error.replace(`Row ${rowNumber}:`, '').trim());
                });

                // Create detailed error message
                let errorMessage = `<strong>${result.skipped_count} rows skipped:</strong><br /><br />`;

                Object.keys(errorsByType).slice(0, 5).forEach(rowNumber => {
                    errorMessage += `<strong>Row ${rowNumber}:</strong><br/>`;
                    errorsByType[rowNumber].forEach(error => {
                        errorMessage += `• ${error}<br/>`;
                    });
                    errorMessage += `<br />`;
                });

                if (Object.keys(errorsByType).length > 5) {
                    errorMessage += `... and ${Object.keys(errorsByType).length - 5} more rows with issues`;
                }

                Swal.fire({
                    title: 'Import Completed with Issues',
                    html: errorMessage,
                    icon: 'warning',
                    confirmButtonText: 'OK',
                    width: 600,
                    customClass: {
                        popup: 'import-warning-popup'
                    }
                });
            }

            // Refresh the deals list
            fetchDeals();

            // Reset file input
            event.target.value = '';

        } catch (error) {
            console.error('Import error:', error);
            const errorMessage = error.response?.data?.error || 'Failed to import orders';

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: errorMessage,
                timer: 4000,
                showConfirmButton: false
            });
        } finally {
            setImportLoading(false);
        }
    };
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <div className={isSubComponent ? "" : "main-content"}>
                <div className={isSubComponent ? "" : "page-content"}>
                    <div className={isSubComponent ? "" : "container-fluid"}>
                        {!isSubComponent && (
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                        <h4 className="mb-sm-0 font-size-18">Orders</h4>
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-body">

                                        <Tabs selectedIndex={activeTab} onSelect={setActiveTab}>
                                            {/* Header Row */}
                                            <div className="d-flex flex-wrap justify-content-between align-items-center mb-2 gap-3">
                                                {/* Left: Tab List */}
                                                <TabList className="d-flex gap-2 mb-0 border-bottom-0">
                                                    <Tab className="px-3 py-2 cursor-pointer" selectedClassName="border-bottom border-primary border-4 text-primary fw-bold">All Orders</Tab>
                                                    <Tab className="px-3 py-2 cursor-pointer" selectedClassName="border-bottom border-primary border-4 text-primary fw-bold">Subscriptions</Tab>
                                                    <Tab className="px-3 py-2 cursor-pointer" selectedClassName="border-bottom border-primary border-4 text-primary fw-bold">Deployment</Tab>
                                                </TabList>

                                                {/* Right: Actions */}
                                                <div className="d-flex align-items-center gap-2">
                                                    <button type="button" className="btn btn-sm btn-light border" onClick={handleExport} title="Export Excel">
                                                        <i className="mdi mdi-file-excel text-success me-1"></i> Export
                                                    </button>
                                                    <input type="file" accept=".xlsx,.xls" id="importLeadsFile" onChange={handleImport} style={{ display: "none" }} />
                                                    <label htmlFor="importLeadsFile" className="btn btn-sm btn-light border mb-0" title="Import Excel">
                                                        <i className="mdi mdi-upload text-primary me-1"></i> Import
                                                    </label>
                                                    <button type="button" className="btn btn-sm btn-primary d-flex align-items-center gap-1" onClick={() => setShowDirectOrderModal(true)}>
                                                        <i className="mdi mdi-plus"></i> Add Order
                                                    </button>
                                                </div>
                                            </div>

                                            {/* Filter Card - Styled like Invoice List */}
                                            <div className="card filter-card mb-3 border-0 shadow-sm" style={{ background: '#f8f9fa' }}>
                                                <div className="card-body p-3">
                                                    <div className="row g-3 align-items-end">
                                                        {/* Issue Date Range */}
                                                        <div className="col-md-3">
                                                            <label className="form-label small fw-bold text-muted mb-1">Issue Date</label>
                                                            <div className="d-flex gap-1 align-items-center">
                                                                <DatePicker
                                                                    views={["year", "month", "day"]}
                                                                    openTo="year"
                                                                    value={issueDateFilter.from ? dayjs(issueDateFilter.from) : null}
                                                                    onChange={(newValue) => {
                                                                        if (newValue) {
                                                                            if (!issueDateFilter.from || dayjs(issueDateFilter.from).year() !== newValue.year()) {
                                                                                setIssueDateFilter({
                                                                                    from: newValue.startOf('year').format('YYYY-MM-DD'),
                                                                                    to: newValue.endOf('year').format('YYYY-MM-DD')
                                                                                });
                                                                            } else {
                                                                                setIssueDateFilter(prev => ({ ...prev, from: newValue.format('YYYY-MM-DD') }));
                                                                            }
                                                                        } else {
                                                                            setIssueDateFilter(prev => ({ ...prev, from: '' }));
                                                                        }
                                                                    }}
                                                                    format="DD-MM-YYYY"
                                                                    slotProps={{
                                                                        textField: {
                                                                            size: 'small',
                                                                            placeholder: 'From',
                                                                            fullWidth: true,
                                                                            sx: {
                                                                                '& .MuiInputBase-root': { height: '31px', fontSize: '13px' },
                                                                                '& .MuiInputBase-input': { padding: '4px 8px' },
                                                                                backgroundColor: 'white'
                                                                            }
                                                                        }
                                                                    }}
                                                                />
                                                                <span className="text-muted small">to</span>
                                                                <DatePicker
                                                                    views={["year", "month", "day"]}
                                                                    openTo="year"
                                                                    value={issueDateFilter.to ? dayjs(issueDateFilter.to) : null}
                                                                    onChange={(newValue) => setIssueDateFilter(prev => ({ ...prev, to: newValue ? newValue.format('YYYY-MM-DD') : '' }))}
                                                                    format="DD-MM-YYYY"
                                                                    slotProps={{
                                                                        textField: {
                                                                            size: 'small',
                                                                            placeholder: 'To',
                                                                            fullWidth: true,
                                                                            sx: {
                                                                                '& .MuiInputBase-root': { height: '31px', fontSize: '13px' },
                                                                                '& .MuiInputBase-input': { padding: '4px 8px' },
                                                                                backgroundColor: 'white'
                                                                            }
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* End Date Range */}
                                                        <div className="col-md-3">
                                                            <label className="form-label small fw-bold text-muted mb-1">Subscription Date</label>
                                                            <div className="d-flex gap-1 align-items-center">
                                                                <DatePicker
                                                                    views={["year", "month", "day"]}
                                                                    openTo="year"
                                                                    value={dateRange.from ? dayjs(dateRange.from) : null}
                                                                    onChange={(newValue) => {
                                                                        if (newValue) {
                                                                            if (!dateRange.from || dayjs(dateRange.from).year() !== newValue.year()) {
                                                                                setDateRange({
                                                                                    from: newValue.startOf('year').format('YYYY-MM-DD'),
                                                                                    to: newValue.endOf('year').format('YYYY-MM-DD')
                                                                                });
                                                                            } else {
                                                                                setDateRange(prev => ({ ...prev, from: newValue.format('YYYY-MM-DD') }));
                                                                            }
                                                                        } else {
                                                                            setDateRange(prev => ({ ...prev, from: '' }));
                                                                        }
                                                                    }}
                                                                    format="DD-MM-YYYY"
                                                                    slotProps={{
                                                                        textField: {
                                                                            size: 'small',
                                                                            placeholder: 'From',
                                                                            fullWidth: true,
                                                                            sx: {
                                                                                '& .MuiInputBase-root': { height: '31px', fontSize: '13px' },
                                                                                '& .MuiInputBase-input': { padding: '4px 8px' },
                                                                                backgroundColor: 'white'
                                                                            }
                                                                        }
                                                                    }}
                                                                />
                                                                <span className="text-muted small">to</span>
                                                                <DatePicker
                                                                    views={["year", "month", "day"]}
                                                                    openTo="year"
                                                                    value={dateRange.to ? dayjs(dateRange.to) : null}
                                                                    onChange={(newValue) => setDateRange(prev => ({ ...prev, to: newValue ? newValue.format('YYYY-MM-DD') : '' }))}
                                                                    format="DD-MM-YYYY"
                                                                    slotProps={{
                                                                        textField: {
                                                                            size: 'small',
                                                                            placeholder: 'To',
                                                                            fullWidth: true,
                                                                            sx: {
                                                                                '& .MuiInputBase-root': { height: '31px', fontSize: '13px' },
                                                                                '& .MuiInputBase-input': { padding: '4px 8px' },
                                                                                backgroundColor: 'white'
                                                                            }
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* Client Selector */}
                                                        {/* Client Selector */}
                                                        <div className="col-md-2">
                                                            <label className="form-label small fw-bold text-muted mb-1">Client</label>
                                                            <select className="form-select form-select-sm" value={clientFilter} onChange={(e) => setClientFilter(e.target.value)} style={{ height: '31px', fontSize: '13px' }}>
                                                                <option value="">All Clients</option>
                                                                {clients.map((client) => (
                                                                    <option key={client.id} value={client.id}>{client.name}</option>
                                                                ))}
                                                            </select>
                                                        </div>

                                                        {/* Project Selector */}
                                                        {!projectId && (
                                                            <div className="col-md-2">
                                                                <label className="form-label small fw-bold text-muted mb-1">Project</label>
                                                                <select className="form-select form-select-sm" value={projectFilter} onChange={(e) => setProjectFilter(e.target.value)} style={{ height: '31px', fontSize: '13px' }}>
                                                                    <option value="">All Projects</option>
                                                                    {projects.map((proj) => (
                                                                        <option key={proj.id} value={proj.id}>{proj.name}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        )}



                                                        {/* Year Multi-select */}
                                                        <div className="col-md-2">
                                                            <label className="form-label small fw-bold text-muted mb-1">Year</label>
                                                            <Select
                                                                isMulti
                                                                options={yearOptions}
                                                                value={yearOptions.filter(opt => yearFilter.includes(opt.value))}
                                                                onChange={(selected) => setYearFilter(selected ? selected.map(opt => opt.value) : [])}
                                                                placeholder="Select Years"
                                                                classNamePrefix="react-select"
                                                                styles={{
                                                                    control: (base) => ({
                                                                        ...base,
                                                                        minHeight: '31px',
                                                                        height: '31px',
                                                                        fontSize: '0.8125rem',
                                                                        borderRadius: '0.25rem',
                                                                        borderColor: yearFilter.length > 0 ? '#556ee6' : '#ced4da',
                                                                        '&:hover': {
                                                                            borderColor: '#556ee6'
                                                                        }
                                                                    }),
                                                                    valueContainer: (base) => ({
                                                                        ...base,
                                                                        height: '31px',
                                                                        padding: '0 8px',
                                                                        marginTop: '-2px'
                                                                    }),
                                                                    input: (base) => ({
                                                                        ...base,
                                                                        margin: '0',
                                                                        padding: '0'
                                                                    }),
                                                                    indicatorsContainer: (base) => ({
                                                                        ...base,
                                                                        height: '31px'
                                                                    }),
                                                                    multiValue: (base) => ({
                                                                        ...base,
                                                                        backgroundColor: '#eff2f7',
                                                                        margin: '1px'
                                                                    }),
                                                                    multiValueLabel: (base) => ({
                                                                        ...base,
                                                                        padding: '0 4px',
                                                                        fontSize: '0.75rem'
                                                                    }),
                                                                    multiValueRemove: (base) => ({
                                                                        ...base,
                                                                        padding: '0 2px',
                                                                        '&:hover': {
                                                                            backgroundColor: '#556ee6',
                                                                            color: 'white'
                                                                        }
                                                                    })
                                                                }}
                                                            />
                                                        </div>

                                                        {userData?.user?.roles?.some(r => r.data_scope === 'all' || r.name === 'superadmin') && (
                                                            <div className="col-md-2">
                                                                <label className="form-label small fw-bold text-muted mb-1">Sales Person</label>
                                                                <select
                                                                    className="form-select form-select-sm"
                                                                    value={salesUserFilter}
                                                                    onChange={(e) => setSalesUserFilter(e.target.value)}
                                                                    style={{ height: '31px', fontSize: '13px' }}
                                                                >
                                                                    <option value="">All Sales Users</option>
                                                                    {salesUsers.map(user => (
                                                                        <option key={user.id} value={user.id}>{user.name}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        )}

                                                        {/* Search */}
                                                        <div className="col-md-2">
                                                            <label className="form-label small fw-bold text-muted mb-1">Search keywords</label>
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text bg-white border-end-0" style={{ height: '31px', padding: '0 8px' }}><i className="bx bx-search-alt text-muted"></i></span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control form-control-sm border-start-0"
                                                                    style={{ height: '31px', fontSize: '13px' }}
                                                                    placeholder="Search..."
                                                                    value={searchQuery}
                                                                    onChange={handleSearchChange}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            applyFilters();
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* Filter Actions */}
                                                        <div className="col-md-2 d-flex gap-2 justify-content-end align-items-end" style={{ height: '54px' }}>
                                                            <button type="button" className="btn btn-sm btn-primary px-3 d-flex align-items-center justify-content-center" style={{ height: '31px', minWidth: '80px' }} onClick={applyFilters}>
                                                                <i className="mdi mdi-filter-variant me-1"></i> Apply
                                                            </button>
                                                            <button type="button" className="btn btn-sm btn-outline-secondary px-3 d-flex align-items-center justify-content-center" style={{ height: '31px', minWidth: '80px' }} onClick={resetFilters}>
                                                                <i className="mdi mdi-refresh me-1"></i> Clear
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Tabs Content */}
                                            <TabPanel>
                                                <OrderTable deals={getFilteredOrders()} />
                                            </TabPanel>
                                            <TabPanel>
                                                <OrderTable deals={getFilteredOrders()} />
                                            </TabPanel>
                                            <TabPanel>
                                                <OrderTable deals={getFilteredOrders()} />
                                            </TabPanel>
                                        </Tabs>




                                        {showVendorsModal && (
                                            <Offcanvas
                                                show={showVendorsModal}
                                                onHide={handleCloseVendorsModal}
                                                placement="end"
                                                backdrop="static"
                                                style={{ width: '550px', borderLeft: '1px solid rgba(0,0,0,0.1)' }}
                                            >
                                                <Offcanvas.Header
                                                    closeButton
                                                    className="border-bottom pb-2"
                                                    style={{
                                                        background: 'linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%)',
                                                        padding: '1.5rem 2rem'
                                                    }}
                                                >
                                                    <div>
                                                        <Offcanvas.Title
                                                            as="h5"
                                                            style={{
                                                                fontWeight: '600',
                                                                fontSize: '1.4rem',
                                                                color: '#2c3e50',
                                                                marginBottom: '0.25rem'
                                                            }}
                                                        >
                                                            Vendor Selection
                                                        </Offcanvas.Title>
                                                        <p className="text-muted mb-0" style={{ fontSize: '0.9rem' }}>
                                                            Select vendor to {selectedQuotationData?.purchase_order?.length ? 'view' : 'create'} purchase order
                                                        </p>
                                                    </div>
                                                </Offcanvas.Header>

                                                <Offcanvas.Body
                                                    className="px-0"
                                                    style={{
                                                        overflowY: 'auto',
                                                        scrollbarWidth: 'thin',
                                                        scrollbarColor: '#d1d8e0 #f1f3f5'
                                                    }}
                                                >
                                                    <div className="px-4 pt-3 pb-2"></div>

                                                    <div className="px-4">
                                                        {selectedQuotationProducts.length > 0 ? (
                                                            <div className="vendor-list">
                                                                {selectedQuotationProducts.map((product, index) => {
                                                                    const vendorName = vendorNames[product.product?.vendor_id];
                                                                    const vendorId = product.product?.vendor_id;
                                                                    const quotation = selectedQuotationData;

                                                                    const hasPO = quotation?.purchase_order?.some(po => po.vendor_id === vendorId);
                                                                    const existingPO = hasPO ? quotation.purchase_order.find(po => po.vendor_id === vendorId) : null;

                                                                    return (
                                                                        <div
                                                                            key={index}
                                                                            className="card mb-3 shadow-sm"
                                                                            style={{
                                                                                borderLeft: hasPO ? '4px solid #4e73df' : '4px solid #f6c23e',
                                                                                transition: 'all 0.2s ease'
                                                                            }}
                                                                        >
                                                                            <div className="card-body py-3 px-4">
                                                                                <div className="d-flex justify-content-between align-items-center">
                                                                                    <div>
                                                                                        <h6 className="mb-1" style={{ fontWeight: '600' }}>
                                                                                            {vendorName || 'Unknown Vendor'}
                                                                                        </h6>
                                                                                        <small className="text-muted">
                                                                                            {product.product?.product_name || 'Product not specified'}
                                                                                        </small>
                                                                                        {existingPO && (
                                                                                            <div className="mt-1">
                                                                                                <small className="text-primary">
                                                                                                    PO #: {existingPO.ref_no}
                                                                                                </small>
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                    <div>
                                                                                        {hasPO ? (
                                                                                            <button
                                                                                                className="btn btn-sm"
                                                                                                onClick={() => {
                                                                                                    navigate(`/purchase-order/details/${existingPO.id}`);
                                                                                                    handleCloseVendorsModal();
                                                                                                }}
                                                                                                style={{
                                                                                                    background: '#4e73df',
                                                                                                    color: 'white',
                                                                                                    borderRadius: '6px',
                                                                                                    padding: '0.35rem 1rem',
                                                                                                    fontWeight: '500'
                                                                                                }}
                                                                                            >
                                                                                                <i className="mdi mdi-eye-outline me-1"></i> View PO Details
                                                                                            </button>
                                                                                        ) : (
                                                                                            <button
                                                                                                className="btn btn-sm"
                                                                                                onClick={() => handleCreatePurchaseOrder(vendorId)}
                                                                                                style={{
                                                                                                    background: '#f6c23e',
                                                                                                    color: '#2c3e50',
                                                                                                    borderRadius: '6px',
                                                                                                    padding: '0.35rem 1rem',
                                                                                                    fontWeight: '500'
                                                                                                }}
                                                                                            >
                                                                                                <i className="mdi mdi-plus-circle-outline me-1"></i> Create PO
                                                                                            </button>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        ) : (
                                                            <div className="text-center py-5">
                                                                <div className="mb-3" style={{ fontSize: '3rem', color: '#e9ecef' }}>
                                                                    <i className="mdi mdi-account-group-outline"></i>
                                                                </div>
                                                                <h5 className="text-muted mb-2">No Vendors Available</h5>
                                                                <p className="text-muted" style={{ fontSize: '0.9rem' }}>
                                                                    This quotation doesn't have any products with assigned vendors.
                                                                </p>
                                                            </div>
                                                        )}
                                                    </div>
                                                </Offcanvas.Body>

                                                <div
                                                    className="border-top px-4 py-3 d-flex justify-content-between align-items-center"
                                                    style={{ background: '#f8f9fa' }}
                                                >
                                                    <div>
                                                        <span className="text-muted small">
                                                            Showing {selectedQuotationProducts.length} vendor{selectedQuotationProducts.length !== 1 ? 's' : ''}
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <button
                                                            className="btn btn-outline-secondary btn-sm"
                                                            onClick={handleCloseVendorsModal}
                                                            style={{
                                                                borderRadius: '6px',
                                                                padding: '0.35rem 1rem',
                                                                fontWeight: '500'
                                                            }}
                                                        >
                                                            <i className="mdi mdi-close-circle-outline me-1"></i> Close
                                                        </button>
                                                    </div>
                                                </div>
                                            </Offcanvas>
                                        )}

                                        {/* Order Details Offcanvas */}
                                        {/* <Offcanvas
                                        show={showOrderDetails}
                                        onHide={() => setShowOrderDetails(false)}
                                        placement="end"
                                        style={{ width: '650px' }}
                                        className="order-details-offcanvas"
                                    >
                                        <Offcanvas.Header closeButton className="bg-light border-bottom">
                                            <Offcanvas.Title>
                                                <div className="d-flex align-items-center">
                                                    <div className="bg-primary rounded p-2 me-3">
                                                        <i className="mdi mdi-clipboard-check-outline text-white fs-4"></i>
                                                    </div>
                                                    <div>
                                                        <h4 className="mb-0 fw-bold">Order Details</h4>
                                                        <p className="text-muted mb-0 small">
                                                            {selectedOrderDetails?.name}
                                                        </p>
                                                    </div>
                                                </div>
                                            </Offcanvas.Title>
                                        </Offcanvas.Header>

                                        <Offcanvas.Body className="p-0">
                                            {selectedOrderDetails && (
                                                <div className="order-details-content">
                                                    <div className="bg-light bg-opacity-10 p-4 border-bottom">
                                                        <div className="row g-3">
                                                            <div className="col-md-4">
                                                                <div className="text-center">
                                                                    <div className="text-muted small mb-1">Total Amount</div>
                                                                    <div className="h5 fw-bold text-primary mb-0">
                                                                        {Number(selectedOrderDetails.value || 0).toLocaleString('en-AE', {
                                                                            minimumFractionDigits: 2,
                                                                            maximumFractionDigits: 2
                                                                        })}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="text-center">
                                                                    <div className="text-muted small mb-1">Order Date</div>
                                                                    <div className="h6 fw-semibold mb-0">
                                                                        {selectedOrderDetails.issue_date ?
                                                                            new Date(selectedOrderDetails.issue_date).toLocaleDateString() :
                                                                            'Not set'
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="text-center">
                                                                    <div className="text-muted small mb-1">Status</div>
                                                                    <span className="badge bg-success fs-6 px-3 py-2">
                                                                        {selectedOrderDetails.stage}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="p-4 border-bottom">
                                                        <div className="d-flex align-items-center mb-3">
                                                            <i className="mdi mdi-office-building-outline text-primary me-2 fs-5"></i>
                                                            <h5 className="mb-0 fw-semibold">Client & Project</h5>
                                                        </div>
                                                        <div className="row g-3">
                                                            <div className="col-sm-6">
                                                                <div className="card border-0 bg-light">
                                                                    <div className="card-body p-3">
                                                                        <div className="d-flex align-items-center mb-2">
                                                                            <i className="mdi mdi-account-outline text-muted me-2"></i>
                                                                            <label className="form-label fw-semibold text-muted mb-0 small">Client</label>
                                                                        </div>
                                                                        <p className="mb-0 fw-medium">{selectedOrderDetails.quotation?.project?.client?.name || 'N/A'}</p>
                                                                        {selectedOrderDetails.quotation?.project?.client?.email && (
                                                                            <small className="text-muted">{selectedOrderDetails.quotation.project.client.email}</small>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-6">
                                                                <div className="card border-0 bg-light">
                                                                    <div className="card-body p-3">
                                                                        <div className="d-flex align-items-center mb-2">
                                                                            <i className="mdi mdi-briefcase-outline text-muted me-2"></i>
                                                                            <label className="form-label fw-semibold text-muted mb-0 small">Project</label>
                                                                        </div>
                                                                        <p className="mb-0 fw-medium">{selectedOrderDetails.quotation?.project?.name || 'N/A'}</p>
                                                                        {selectedOrderDetails.quotation?.project?.start_date && (
                                                                            <small className="text-muted">
                                                                                Started: {new Date(selectedOrderDetails.quotation.project.start_date).toLocaleDateString()}
                                                                            </small>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="p-4 border-bottom">
                                                        <div className="d-flex align-items-center mb-3">
                                                            <i className="mdi mdi-file-document-outline text-primary me-2 fs-5"></i>
                                                            <h5 className="mb-0 fw-semibold">Quotation Details</h5>
                                                        </div>
                                                        <div className="row g-3">
                                                            <div className="col-sm-6">
                                                                <label className="form-label fw-semibold text-muted small mb-1">Reference No</label>
                                                                <p className="mb-2 fw-medium">{selectedOrderDetails.quotation?.ref_no || 'N/A'}</p>
                                                            </div>
                                                            <div className="col-sm-6">
                                                                <label className="form-label fw-semibold text-muted small mb-1">Quotation Date</label>
                                                                <p className="mb-2">
                                                                    {selectedOrderDetails.quotation?.quotation_date ?
                                                                        new Date(selectedOrderDetails.quotation.quotation_date).toLocaleDateString() :
                                                                        'N/A'
                                                                    }
                                                                </p>
                                                            </div>
                                                            <div className="col-sm-6">
                                                                <label className="form-label fw-semibold text-muted small mb-1">Status</label>
                                                                <div>
                                                                    <span className={`badge ${selectedOrderDetails.quotation?.status === 'confirmed' ? 'bg-success' : 'bg-warning'}`}>
                                                                        {selectedOrderDetails.quotation?.status || 'N/A'}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-6">
                                                                <label className="form-label fw-semibold text-muted small mb-1">Quotation Amount</label>
                                                                <p className="mb-0 fw-bold text-primary">
                                                                    {Number(selectedOrderDetails.quotation?.amount || 0).toLocaleString('en-AE', {
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2
                                                                    })} {selectedOrderDetails.quotation?.project?.client?.currency || 'USD'}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>



                                                  
                                                    {(selectedOrderDetails.quotation?.project?.subscription_start_date || selectedOrderDetails.quotation?.project?.deployment_start_date) && (
                                                        <div className="p-4 border-bottom">
                                                            <div className="d-flex align-items-center mb-3">
                                                                <i className="mdi mdi-calendar-range text-primary me-2 fs-5"></i>
                                                                <h5 className="mb-0 fw-semibold">Timeline</h5>
                                                            </div>
                                                            <div className="row g-3">
                                                                {selectedOrderDetails.quotation?.project?.subscription_start_date && (
                                                                    <>
                                                                        <div className="col-sm-6">
                                                                            <div className="card border-0 bg-light">
                                                                                <div className="card-body p-3">
                                                                                    <div className="d-flex align-items-center mb-2">
                                                                                        <i className="mdi mdi-calendar-start text-success me-2"></i>
                                                                                        <label className="form-label fw-semibold text-muted mb-0 small">Subscription Start</label>
                                                                                    </div>
                                                                                    <p className="mb-0 fw-medium">
                                                                                        {new Date(selectedOrderDetails.quotation.project.subscription_start_date).toLocaleDateString()}
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-sm-6">
                                                                            <div className="card border-0 bg-light">
                                                                                <div className="card-body p-3">
                                                                                    <div className="d-flex align-items-center mb-2">
                                                                                        <i className="mdi mdi-calendar-end text-warning me-2"></i>
                                                                                        <label className="form-label fw-semibold text-muted mb-0 small">Subscription End</label>
                                                                                    </div>
                                                                                    <p className="mb-0 fw-medium">
                                                                                        {selectedOrderDetails.quotation.project.vendor_subscription_end_dates ?
                                                                                            new Date(selectedOrderDetails.quotation.project.vendor_subscription_end_dates).toLocaleDateString() :
                                                                                            'Not set'
                                                                                        }
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )}
                                                                {selectedOrderDetails.quotation?.project?.deployment_start_date && (
                                                                    <>
                                                                        <div className="col-sm-6">
                                                                            <div className="card border-0 bg-light">
                                                                                <div className="card-body p-3">
                                                                                    <div className="d-flex align-items-center mb-2">
                                                                                        <i className="mdi mdi-rocket-launch-outline text-info me-2"></i>
                                                                                        <label className="form-label fw-semibold text-muted mb-0 small">Deployment Start</label>
                                                                                    </div>
                                                                                    <p className="mb-0 fw-medium">
                                                                                        {new Date(selectedOrderDetails.quotation.project.deployment_start_date).toLocaleDateString()}
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-sm-6">
                                                                            <div className="card border-0 bg-light">
                                                                                <div className="card-body p-3">
                                                                                    <div className="d-flex align-items-center mb-2">
                                                                                        <i className="mdi mdi-flag-checkered text-danger me-2"></i>
                                                                                        <label className="form-label fw-semibold text-muted mb-0 small">Deployment End</label>
                                                                                    </div>
                                                                                    <p className="mb-0 fw-medium">
                                                                                        {selectedOrderDetails.quotation.project.deployment_end_date ?
                                                                                            new Date(selectedOrderDetails.quotation.project.deployment_end_date).toLocaleDateString() :
                                                                                            'Not set'
                                                                                        }
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}

                                                    <div className="p-4">
                                                        <div className="d-flex align-items-center mb-3">
                                                            <i className="mdi mdi-information-outline text-primary me-2 fs-5"></i>
                                                            <h5 className="mb-0 fw-semibold">Additional Information</h5>
                                                        </div>
                                                        <div className="row g-3">
                                                            {selectedOrderDetails.remarks && (
                                                                <div className="col-12">
                                                                    <label className="form-label fw-semibold text-muted small mb-1">Remarks</label>
                                                                    <div className="card border-0 bg-light">
                                                                        <div className="card-body">
                                                                            <p className="mb-0">{selectedOrderDetails.remarks}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}

                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </Offcanvas.Body>
                                    </Offcanvas> */}

                                        <Offcanvas
                                            show={showOrderDetails}
                                            onHide={() => setShowOrderDetails(false)}
                                            placement="end"
                                            style={{ width: '800px' }} // Increased width for better product display
                                            className="order-details-offcanvas"
                                        >
                                            <Offcanvas.Header closeButton className="bg-light border-bottom">
                                                <Offcanvas.Title>
                                                    <div className="d-flex align-items-center">
                                                        <div className="bg-primary rounded p-2 me-3">
                                                            <i className="mdi mdi-clipboard-check-outline text-white fs-4"></i>
                                                        </div>
                                                        <div>
                                                            <h4 className="mb-0 fw-bold">Order Details</h4>
                                                            <p className="text-muted mb-0 small">
                                                                {selectedOrderDetails?.name}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </Offcanvas.Title>
                                            </Offcanvas.Header>

                                            <Offcanvas.Body className="p-0">
                                                {selectedOrderDetails && (
                                                    <div className="order-details-content">
                                                        {/* Header Summary */}
                                                        <div className="bg-light bg-opacity-10 p-4 border-bottom">
                                                            <div className="row g-3">
                                                                <div className="col-md-3">
                                                                    <div className="text-center">
                                                                        <div className="text-muted small mb-1">Total Amount</div>
                                                                        <div className="h5 fw-bold text-primary mb-0">
                                                                            {Number(selectedOrderDetails.value || 0).toLocaleString('en-AE', {
                                                                                minimumFractionDigits: 2,
                                                                                maximumFractionDigits: 2
                                                                            })}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <div className="text-center">
                                                                        <div className="text-muted small mb-1">Subscription</div>
                                                                        <div className="h6 fw-semibold text-success mb-0">
                                                                            {Number(selectedOrderDetails.quotation?.total_amount_with_subscription || 0).toLocaleString('en-AE', {
                                                                                minimumFractionDigits: 2,
                                                                                maximumFractionDigits: 2
                                                                            })}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <div className="text-center">
                                                                        <div className="text-muted small mb-1">Deployment</div>
                                                                        <div className="h6 fw-semibold text-info mb-0">
                                                                            {Number(selectedOrderDetails.quotation?.deplyment_amount || 0).toLocaleString('en-AE', {
                                                                                minimumFractionDigits: 2,
                                                                                maximumFractionDigits: 2
                                                                            })}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <div className="text-center">
                                                                        <div className="text-muted small mb-1">Status</div>
                                                                        <span className="badge bg-success fs-6 px-3 py-2">
                                                                            {selectedOrderDetails.stage}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Client & Project Section */}
                                                        <div className="p-4 border-bottom">
                                                            <div className="d-flex align-items-center mb-3">
                                                                <i className="mdi mdi-office-building-outline text-primary me-2 fs-5"></i>
                                                                <h5 className="mb-0 fw-semibold">Client & Project</h5>
                                                            </div>
                                                            <div className="row g-3">
                                                                <div className="col-sm-6">
                                                                    <div className="card border-0 bg-light">
                                                                        <div className="card-body p-3">
                                                                            <div className="d-flex align-items-center mb-2">
                                                                                <i className="mdi mdi-account-outline text-muted me-2"></i>
                                                                                <label className="form-label fw-semibold text-muted mb-0 small">Client</label>
                                                                            </div>
                                                                            <p className="mb-0 fw-medium">{selectedOrderDetails.quotation?.project?.client?.name || 'N/A'}</p>
                                                                            {selectedOrderDetails.quotation?.project?.client?.email && (
                                                                                <small className="text-muted">{selectedOrderDetails.quotation.project.client.email}</small>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-sm-6">
                                                                    <div className="card border-0 bg-light">
                                                                        <div className="card-body p-3">
                                                                            <div className="d-flex align-items-center mb-2">
                                                                                <i className="mdi mdi-briefcase-outline text-muted me-2"></i>
                                                                                <label className="form-label fw-semibold text-muted mb-0 small">Project</label>
                                                                            </div>
                                                                            <p className="mb-0 fw-medium">{selectedOrderDetails.quotation?.project?.name || 'N/A'}</p>
                                                                            {selectedOrderDetails.quotation?.project?.start_date && (
                                                                                <small className="text-muted">
                                                                                    Started: {new Date(selectedOrderDetails.quotation.project.start_date).toLocaleDateString()}
                                                                                </small>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Product Details Section */}
                                                        <div className="p-4 border-bottom">
                                                            <div className="d-flex align-items-center justify-content-between mb-3">
                                                                <div className="d-flex align-items-center">
                                                                    <i className="mdi mdi-package-variant text-primary me-2 fs-5"></i>
                                                                    <h5 className="mb-0 fw-semibold">Product Details</h5>
                                                                </div>
                                                                <span className="badge bg-primary">
                                                                    {selectedOrderDetails.product_item_details?.length || 0} Products
                                                                </span>
                                                            </div>

                                                            <div className="table-responsive">
                                                                <table className="table table-sm table-hover">
                                                                    <thead className="table-sales-gradient">
                                                                        <tr>
                                                                            <th>Product Name</th>
                                                                            <th>Type</th>
                                                                            <th>Quantity</th>
                                                                            <th>Price</th>
                                                                            <th>Subtotal</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {selectedOrderDetails.product_item_details?.map((product, index) => (
                                                                            <tr key={index}>
                                                                                <td>
                                                                                    <div className="d-flex align-items-center">
                                                                                        <div className="me-2">
                                                                                            <i className={`mdi ${product.product?.license_type === 'service'
                                                                                                ? 'mdi-tools'
                                                                                                : 'mdi-license'
                                                                                                } text-muted`}></i>
                                                                                        </div>
                                                                                        <div>
                                                                                            <div className="fw-medium">{product.item_name}</div>
                                                                                            {product.product?.description && (
                                                                                                <small className="text-muted">{product.product.description}</small>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                </td>
                                                                                <td>
                                                                                    <span className={`badge ${product.product?.license_type === 'service'
                                                                                        ? 'bg-info'
                                                                                        : 'bg-success'
                                                                                        }`}>
                                                                                        {product.product?.license_type || 'license'}
                                                                                    </span>
                                                                                </td>
                                                                                <td>{product.quantity}</td>
                                                                                <td>
                                                                                    {Number(product.price || 0).toLocaleString('en-AE', {
                                                                                        minimumFractionDigits: 2,
                                                                                        maximumFractionDigits: 2
                                                                                    })}
                                                                                </td>
                                                                                <td className="fw-bold">
                                                                                    {Number(product.subtotal || 0).toLocaleString('en-AE', {
                                                                                        minimumFractionDigits: 2,
                                                                                        maximumFractionDigits: 2
                                                                                    })}
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                    <tfoot className="table-sales-gradient">
                                                                        <tr>
                                                                            <td colSpan="4" className="text-end fw-bold">Total:</td>
                                                                            <td className="fw-bold text-primary">
                                                                                {Number(selectedOrderDetails.quotation?.amount || 0).toLocaleString('en-AE', {
                                                                                    minimumFractionDigits: 2,
                                                                                    maximumFractionDigits: 2
                                                                                })}
                                                                            </td>
                                                                        </tr>
                                                                    </tfoot>
                                                                </table>
                                                            </div>
                                                        </div>

                                                        {/* Revenue Breakdown */}
                                                        <div className="p-4 border-bottom">
                                                            <div className="d-flex align-items-center mb-3">
                                                                <i className="mdi mdi-chart-pie text-primary me-2 fs-5"></i>
                                                                <h5 className="mb-0 fw-semibold">Revenue Breakdown</h5>
                                                            </div>
                                                            <div className="row g-3">
                                                                <div className="col-md-6">
                                                                    <div className="card border-success border-opacity-25">
                                                                        <div className="card-body">
                                                                            <div className="d-flex align-items-center mb-2">
                                                                                <i className="mdi mdi-calendar-text text-success me-2"></i>
                                                                                <h6 className="mb-0 fw-semibold">Recurring Cost</h6>
                                                                            </div>
                                                                            <div className="d-flex justify-content-between align-items-center">
                                                                                <span className="text-muted">Amount:</span>
                                                                                <span className="fw-bold text-success">
                                                                                    {Number(selectedOrderDetails.quotation?.total_amount_with_subscription || 0).toLocaleString('en-AE', {
                                                                                        minimumFractionDigits: 2,
                                                                                        maximumFractionDigits: 2
                                                                                    })}
                                                                                </span>
                                                                            </div>
                                                                            <div className="d-flex justify-content-between align-items-center mt-1">
                                                                                <span className="text-muted">Period:</span>
                                                                                <span className="fw-medium">
                                                                                    {selectedOrderDetails.quotation?.subscription_period || 12} months
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="card border-info border-opacity-25">
                                                                        <div className="card-body">
                                                                            <div className="d-flex align-items-center mb-2">
                                                                                <i className="mdi mdi-rocket-launch text-info me-2"></i>
                                                                                <h6 className="mb-0 fw-semibold">One Time Cost</h6>
                                                                            </div>
                                                                            <div className="d-flex justify-content-between align-items-center">
                                                                                <span className="text-muted">Amount:</span>
                                                                                <span className="fw-bold text-info">
                                                                                    {Number(selectedOrderDetails.quotation?.deplyment_amount || 0).toLocaleString('en-AE', {
                                                                                        minimumFractionDigits: 2,
                                                                                        maximumFractionDigits: 2
                                                                                    })}
                                                                                </span>
                                                                            </div>
                                                                            <div className="d-flex justify-content-between align-items-center mt-1">
                                                                                <span className="text-muted">Model Type:</span>
                                                                                <span className="fw-medium">
                                                                                    {selectedOrderDetails.quotation?.model_type || selectedOrderDetails?.model_type}
                                                                                </span>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Quotation Details */}
                                                        <div className="p-4 border-bottom">
                                                            <div className="d-flex align-items-center mb-3">
                                                                <i className="mdi mdi-file-document-outline text-primary me-2 fs-5"></i>
                                                                <h5 className="mb-0 fw-semibold">Quotation Details</h5>
                                                            </div>
                                                            <div className="row g-3">
                                                                <div className="col-sm-6">
                                                                    <label className="form-label fw-semibold text-muted small mb-1">Reference No</label>
                                                                    <p className="mb-2 fw-medium">{selectedOrderDetails.quotation?.ref_no || 'N/A'}</p>
                                                                </div>
                                                                <div className="col-sm-6">
                                                                    <label className="form-label fw-semibold text-muted small mb-1">Quotation Date</label>
                                                                    <p className="mb-2">
                                                                        {selectedOrderDetails.quotation?.date ?
                                                                            new Date(selectedOrderDetails.quotation.date).toLocaleDateString() :
                                                                            ' '
                                                                        }
                                                                    </p>
                                                                </div>

                                                                <div className="col-sm-6">
                                                                    <label className="form-label fw-semibold text-muted small mb-1">Total Amount</label>
                                                                    <p className="mb-0 fw-bold text-primary">
                                                                        {Number(selectedOrderDetails.quotation?.amount || 0).toLocaleString('en-AE', {
                                                                            minimumFractionDigits: 2,
                                                                            maximumFractionDigits: 2
                                                                        })} {selectedOrderDetails.quotation?.project?.client?.currency || 'USD'}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="p-4 border-bottom">
                                                            <div className="d-flex align-items-center mb-3">
                                                                <i className="mdi mdi-file-document-outline text-primary me-2 fs-5"></i>
                                                                <h5 className="mb-0 fw-semibold">PO Details</h5>
                                                            </div>
                                                            <div className="row g-3">
                                                                <div className="col-sm-6">
                                                                    <div className="card border-0 bg-light">
                                                                        <div className="card-body p-3">
                                                                            <div className="d-flex align-items-center mb-2">

                                                                                <label className="form-label fw-semibold text-muted mb-0 small">PO Number</label>
                                                                            </div>

                                                                            <p className="mb-0 fw-medium">{selectedOrderDetails.po_number || 'N/A'}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-sm-6">
                                                                    <div className="card border-0 bg-light">
                                                                        <div className="card-body p-3">
                                                                            <div className="d-flex align-items-center mb-2">

                                                                                <label className="form-label fw-semibold text-muted mb-0 small">Date</label>
                                                                            </div>

                                                                            <p className="mb-0 fw-medium">
                                                                                {selectedOrderDetails.issue_date ?
                                                                                    new Date(selectedOrderDetails.issue_date).toLocaleDateString() :
                                                                                    ' '
                                                                                }
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-sm-6">
                                                                    <div className="card border-0 bg-light">
                                                                        <div className="card-body p-3">
                                                                            <div className="d-flex align-items-center mb-2">

                                                                                <label className="form-label fw-semibold text-muted mb-0 small">PO Value</label>
                                                                            </div>

                                                                            <p className="mb-0 fw-medium">
                                                                                {Number(selectedOrderDetails.po_value || 0).toLocaleString('en-AE', {
                                                                                    minimumFractionDigits: 2,
                                                                                    maximumFractionDigits: 2
                                                                                })}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div></div>

                                                        {/* Timeline Information */}
                                                        {(selectedOrderDetails.quotation?.project?.subscription_start_date || selectedOrderDetails.quotation?.project?.deployment_start_date) && (
                                                            <div className="p-4 border-bottom">
                                                                <div className="d-flex align-items-center mb-3">
                                                                    <i className="mdi mdi-calendar-range text-primary me-2 fs-5"></i>
                                                                    <h5 className="mb-0 fw-semibold">Timeline</h5>
                                                                </div>
                                                                <div className="row g-3">
                                                                    {selectedOrderDetails.quotation?.project?.subscription_start_date && (
                                                                        <>
                                                                            <div className="col-sm-6">
                                                                                <div className="card border-0 bg-light">
                                                                                    <div className="card-body p-3">
                                                                                        <div className="d-flex align-items-center mb-2">
                                                                                            <i className="mdi mdi-calendar-start text-success me-2"></i>
                                                                                            <label className="form-label fw-semibold text-muted mb-0 small">Subscription Start</label>
                                                                                        </div>
                                                                                        <p className="mb-0 fw-medium">
                                                                                            {new Date(selectedOrderDetails.quotation.project.subscription_start_date).toLocaleDateString()}
                                                                                        </p>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-sm-6">
                                                                                <div className="card border-0 bg-light">
                                                                                    <div className="card-body p-3">
                                                                                        <div className="d-flex align-items-center mb-2">
                                                                                            <i className="mdi mdi-calendar-end text-warning me-2"></i>
                                                                                            <label className="form-label fw-semibold text-muted mb-0 small">Subscription End</label>
                                                                                        </div>
                                                                                        <p className="mb-0 fw-medium">
                                                                                            {selectedOrderDetails.quotation.project.vendor_subscription_end_dates ?
                                                                                                new Date(selectedOrderDetails.quotation.project.vendor_subscription_end_dates).toLocaleDateString() :
                                                                                                'Not set'
                                                                                            }
                                                                                        </p>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                    {selectedOrderDetails.quotation?.project?.deployment_start_date && (
                                                                        <>
                                                                            <div className="col-sm-6">
                                                                                <div className="card border-0 bg-light">
                                                                                    <div className="card-body p-3">
                                                                                        <div className="d-flex align-items-center mb-2">
                                                                                            <i className="mdi mdi-rocket-launch-outline text-info me-2"></i>
                                                                                            <label className="form-label fw-semibold text-muted mb-0 small">Deployment Start</label>
                                                                                        </div>
                                                                                        <p className="mb-0 fw-medium">
                                                                                            {new Date(selectedOrderDetails.quotation.project.deployment_start_date).toLocaleDateString()}
                                                                                        </p>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-sm-6">
                                                                                <div className="card border-0 bg-light">
                                                                                    <div className="card-body p-3">
                                                                                        <div className="d-flex align-items-center mb-2">
                                                                                            <i className="mdi mdi-flag-checkered text-danger me-2"></i>
                                                                                            <label className="form-label fw-semibold text-muted mb-0 small">Deployment End</label>
                                                                                        </div>
                                                                                        <p className="mb-0 fw-medium">
                                                                                            {selectedOrderDetails.quotation.project.deployment_end_date ?
                                                                                                new Date(selectedOrderDetails.quotation.project.deployment_end_date).toLocaleDateString() :
                                                                                                'Not set'
                                                                                            }
                                                                                        </p>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )}

                                                        {/* Additional Information */}
                                                        <div className="p-4">
                                                            <div className="d-flex align-items-center mb-3">
                                                                <i className="mdi mdi-information-outline text-primary me-2 fs-5"></i>
                                                                <h5 className="mb-0 fw-semibold">Additional Information</h5>
                                                            </div>
                                                            <div className="row g-3">
                                                                {selectedOrderDetails.remarks && (
                                                                    <div className="col-12">
                                                                        <label className="form-label fw-semibold text-muted small mb-1">Remarks</label>
                                                                        <div className="card border-0 bg-light">
                                                                            <div className="card-body">
                                                                                <p className="mb-0">{selectedOrderDetails.remarks}</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </Offcanvas.Body>
                                        </Offcanvas>


                                        {/* PO Attachment Modal */}
                                        {/* <Offcanvas
    show={showPOAttachmentModal}
    onHide={() => setShowPOAttachmentModal(false)}
    placement="end"
    style={{ width: '500px' }}
>
    <Offcanvas.Header closeButton className="bg-light border-bottom">
        <Offcanvas.Title>
            <div className="d-flex align-items-center">
                <i className="mdi mdi-paperclip text-primary me-2 fs-4"></i>
                <div>
                    <h4 className="mb-0 fw-bold">PO Attachment</h4>
                    <p className="text-muted mb-0 small">
                        {selectedPOForAttachment?.po_number || 'Add Attachment'}
                    </p>
                </div>
            </div>
        </Offcanvas.Title>
    </Offcanvas.Header>

    <Offcanvas.Body>
        {selectedPOForAttachment && (
            <div className="po-attachment-form">
                <div className="mb-4">
                    <div className="row g-3">
                        <div className="col-12">
                            <label className="form-label fw-semibold">PO Number</label>
                            <input 
                                type="text" 
                                className="form-control" 
                                value={selectedPOForAttachment.po_number || ''} 
                                readOnly 
                            />
                        </div>
                        <div className="col-12">
                            <label className="form-label fw-semibold">PO Value</label>
                            <input 
                                type="text" 
                                className="form-control" 
                                value={Number(selectedPOForAttachment.po_value || 0).toLocaleString('en-AE', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })} 
                                readOnly 
                            />
                        </div>
                        <div className="col-12">
                            <label className="form-label fw-semibold">Issue Date</label>
                            <input 
                                type="text" 
                                className="form-control" 
                                value={selectedPOForAttachment.issue_date ? 
                                    new Date(selectedPOForAttachment.issue_date).toLocaleDateString() : 
                                    'N/A'
                                } 
                                readOnly 
                            />
                        </div>
                    </div>
                </div>

                <div className="border-top pt-4">
                    <h6 className="fw-semibold mb-3">Upload Attachment</h6>
                    
                    <div className="mb-3">
                        <input
                            type="file"
                            className="form-control"
                            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                            onChange={(e) => setPOAttachmentFile(e.target.files[0])}
                        />
                        <div className="form-text">
                            Supported formats: PDF, DOC, DOCX, JPG, PNG (Max: 10MB)
                        </div>
                    </div>

                    {selectedPOForAttachment.attachments && selectedPOForAttachment.attachments.length > 0 && (
                        <div className="mb-3">
                            <label className="form-label fw-semibold">Existing Attachments</label>
                            <div className="list-group">
                                {selectedPOForAttachment.attachments.map((attachment, index) => (
                                    <div key={index} className="list-group-item d-flex justify-content-between align-items-center">
                                        <div>
                                            <i className="mdi mdi-file-outline me-2"></i>
                                            <span>{attachment.file_name}</span>
                                        </div>
                                        <div>
                                            <button 
                                                className="btn btn-sm btn-outline-primary me-1"
                                                onClick={() => window.open(attachment.file_url, '_blank')}
                                            >
                                                <i className="mdi mdi-eye"></i>
                                            </button>
                                            <button 
                                                className="btn btn-sm btn-outline-danger"
                                                onClick={() => handleDeleteAttachment(attachment.id)}
                                            >
                                                <i className="mdi mdi-delete"></i>
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    <div className="d-flex gap-2 justify-content-end">
                        <button
                            className="btn btn-secondary"
                            onClick={() => setShowPOAttachmentModal(false)}
                        >
                            Cancel
                        </button>
                        <button
                            className="btn btn-primary"
                            onClick={handleUploadAttachment}
                            disabled={!poAttachmentFile}
                        >
                            <i className="mdi mdi-upload me-1"></i>
                            Upload Attachment
                        </button>
                    </div>
                </div>
            </div>
        )}
    </Offcanvas.Body>
</Offcanvas> */}

                                        <Offcanvas
                                            show={showPOAttachmentModal}
                                            onHide={() => setShowPOAttachmentModal(false)}
                                            placement="end"
                                            style={{ width: '900px' }}
                                        >
                                            <Offcanvas.Header closeButton className="bg-light border-bottom">
                                                <Offcanvas.Title>
                                                    <div className="d-flex align-items-center">
                                                        <i className="mdi mdi-paperclip text-primary me-2 fs-4"></i>
                                                        <div>
                                                            <h4 className="mb-0 fw-bold">PO Attachment</h4>
                                                            <p className="text-muted mb-0 small">
                                                                {selectedPOForAttachment?.po_number || 'Add Attachment'}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </Offcanvas.Title>
                                            </Offcanvas.Header>

                                            <Offcanvas.Body className="p-0">
                                                {selectedPOForAttachment && (
                                                    <div className="d-flex h-100">
                                                        {/* Left Side - Form and Controls */}
                                                        <div className="border-end" style={{ width: '350px', minWidth: '350px' }}>
                                                            <div className="p-4">
                                                                <div className="mb-4">
                                                                    <h6 className="fw-semibold mb-3">PO Information</h6>
                                                                    <div className="row g-3">
                                                                        <div className="col-12">
                                                                            <label className="form-label fw-semibold small">PO Number</label>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control form-control-sm"
                                                                                value={selectedPOForAttachment.po_number || ''}
                                                                                readOnly
                                                                            />
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <label className="form-label fw-semibold small">PO Value</label>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control form-control-sm"
                                                                                value={Number(selectedPOForAttachment.po_value || 0).toLocaleString('en-AE', {
                                                                                    minimumFractionDigits: 2,
                                                                                    maximumFractionDigits: 2
                                                                                })}
                                                                                readOnly
                                                                            />
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <label className="form-label fw-semibold small">Issue Date</label>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control form-control-sm"
                                                                                value={selectedPOForAttachment.issue_date ?
                                                                                    new Date(selectedPOForAttachment.issue_date).toLocaleDateString() :
                                                                                    'N/A'
                                                                                }
                                                                                readOnly
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="border-top pt-4">
                                                                    <h6 className="fw-semibold mb-3">Upload New Attachment</h6>

                                                                    <div className="mb-3">
                                                                        <input
                                                                            id="poAttachmentFile"
                                                                            type="file"
                                                                            className="form-control form-control-sm"
                                                                            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                                                            onChange={handleFileChange}
                                                                        />
                                                                        <div className="form-text small">
                                                                            Supported: PDF, DOC, DOCX, JPG, PNG (Max: 10MB)
                                                                        </div>
                                                                    </div>

                                                                    {poAttachmentFile && (
                                                                        <div className="alert alert-info py-2 mb-3">
                                                                            <div className="d-flex justify-content-between align-items-center">
                                                                                <small>
                                                                                    <i className="mdi mdi-file-outline me-1"></i>
                                                                                    {poAttachmentFile.name}
                                                                                </small>
                                                                                <button
                                                                                    className="btn btn-sm btn-outline-secondary"
                                                                                    onClick={() => {
                                                                                        setPOAttachmentFile(null);
                                                                                        const fileInput = document.querySelector('#poAttachmentFile');
                                                                                        if (fileInput) fileInput.value = '';
                                                                                    }}
                                                                                >
                                                                                    <i className="mdi mdi-close"></i>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    )}

                                                                    <div className="d-flex gap-2">
                                                                        <button
                                                                            className="btn btn-secondary btn-sm flex-fill"
                                                                            onClick={() => setShowPOAttachmentModal(false)}
                                                                        >
                                                                            Cancel
                                                                        </button>
                                                                        <button
                                                                            className="btn btn-primary btn-sm flex-fill"
                                                                            onClick={handleUploadAttachment}
                                                                            disabled={!poAttachmentFile}
                                                                        >
                                                                            <i className="mdi mdi-upload me-1"></i>
                                                                            Upload
                                                                        </button>
                                                                    </div>
                                                                </div>

                                                                {/* Existing Attachments List */}
                                                                {selectedPOForAttachment.attachments && selectedPOForAttachment.attachments.length > 0 && (
                                                                    <div className="border-top pt-4 mt-4">
                                                                        <h6 className="fw-semibold mb-3">Existing Attachments</h6>
                                                                        <div className="list-group list-group-flush">
                                                                            {selectedPOForAttachment.attachments.map((attachment, index) => (
                                                                                <div key={index} className="list-group-item d-flex justify-content-between align-items-center px-0 py-2">
                                                                                    <div className="d-flex align-items-center">
                                                                                        <i className="mdi mdi-file-outline text-muted me-2"></i>
                                                                                        <div>
                                                                                            <small className="d-block fw-medium">{attachment.file_name}</small>
                                                                                            <small className="text-muted">
                                                                                                {new Date(attachment.created_at).toLocaleDateString()}
                                                                                            </small>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="d-flex gap-1">
                                                                                        <button
                                                                                            className="btn btn-sm btn-outline-danger"
                                                                                            onClick={() => handleDeleteAttachment(attachment.id)}
                                                                                            title="Delete"
                                                                                        >
                                                                                            <i className="mdi mdi-delete"></i>
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>

                                                        {/* Right Side - ALWAYS SHOW IFRAME PREVIEW */}
                                                        <div className="flex-fill d-flex flex-column">
                                                            <div className="border-bottom p-3 bg-light">
                                                                <div className="d-flex justify-content-between align-items-center">
                                                                    <h6 className="mb-0 fw-semibold">
                                                                        {selectedPOForAttachment.po_attachment
                                                                            ? 'PO Attachment Preview'
                                                                            : 'No Attachment Available'
                                                                        }
                                                                    </h6>
                                                                </div>
                                                            </div>

                                                            <div className="flex-fill p-3 bg-light">
                                                                {selectedPOForAttachment.po_attachment ? (
                                                                    <div
                                                                        className="bg-white rounded position-relative"
                                                                        style={{
                                                                            height: "100%",   // << SAME fixed 
                                                                            width: "100%",
                                                                            overflow: "hidden",
                                                                            backgroundColor: "#fff",
                                                                        }}
                                                                    >
                                                                        <iframe
                                                                            src={`${process.env.REACT_APP_BACKEND_URL}/storage/${selectedPOForAttachment.po_attachment}#toolbar=0&navpanes=0`}
                                                                            style={{
                                                                                border: "none",
                                                                                width: "100%",
                                                                                height: "100%",  // << FILL the wrapper height
                                                                                backgroundColor: "#fff",
                                                                            }}
                                                                        />
                                                                    </div>
                                                                ) : (
                                                                    <div className="d-flex justify-content-center align-items-center h-100 bg-white rounded"
                                                                        style={{ border: '1px dashed #dee2e6' }}>
                                                                        <div className="text-center text-muted">
                                                                            <i className="mdi mdi-file-document-outline display-4 mb-3"></i>
                                                                            <h6>No PO Attachment</h6>
                                                                            <p className="small mb-0">Upload a file to preview it here</p>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>

                                                    </div>
                                                )}
                                            </Offcanvas.Body>
                                        </Offcanvas>

                                        <div className="d-flex justify-content-end pagination-sm">
                                            <ReactPaginate
                                                previousLabel={'<'}
                                                nextLabel={'>'}
                                                breakLabel={'...'}
                                                pageCount={pageCount}
                                                marginPagesDisplayed={2}
                                                pageRangeDisplayed={3}
                                                onPageChange={handlePageClick}
                                                containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                                                pageClassName={'page-item'}
                                                pageLinkClassName={'page-link'}
                                                previousClassName={'page-item previous'}
                                                previousLinkClassName={'page-link'}
                                                nextClassName={'page-item next'}
                                                nextLinkClassName={'page-link'}
                                                breakClassName={'page-item'}
                                                breakLinkClassName={'page-link'}
                                                activeClassName={'active'}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {showPurchaseOrderModal && (
                <PurchaseOrderForm
                    showModal={showPurchaseOrderModal}
                    poId={poId}
                    vendorId={selectedVendorId}
                    products={selectedQuotationProducts}
                    handleClose={handleClosePurchaseOrderModal}
                    projectId={selectedDealData?.project_id}
                    quotationId={selectedQuotationId}
                    vendors={vendors}
                    isQuotationParent={true}
                    fetchQuotations={fetchQuotations}
                />
            )}

            {showProformaModal && (
                <ProformaInvoiceModal
                    showModal={showProformaModal}
                    quotationData={selectedQuotationData}
                    handleClose={handleCloseProformaModal}
                    quotationId={selectedDealData?.quotation_id}
                    handleCreate={handleCreateProformaInvoice}
                    fetchDeals={fetchDeals}
                />
            )}

            <DealModal
                showModal={showModal}
                handleClose={handleCloseModal}
                dealId={selectedDealId}
                dealData={selectedDealData}
                editDeal={editDeal}
                deals={deals}
                fetchOrganisation={fetchOrganisation}
                organisations={clients}
                revenueType={editingRevenueType}
                isSalesOrderList={true}
            />
            <DirectOrderForm
                showModal={showDirectOrderModal}
                handleClose={() => setShowDirectOrderModal(false)}
                fetchOrders={fetchDeals}
            />
            {showBundleModal && (
                <RevenueBundleModal
                    showModal={showBundleModal}
                    handleClose={handleCloseBundleModal}
                    deal={selectedDealForBundle}
                    fetchDeals={fetchDeals}
                />
            )}
        </LocalizationProvider>
    );
};

export default OrderDealList;
